;(function contactRolesFieldModule() {
  const escapeHtml = (value = '') =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const luxRequestJson = async (url, options = {}) => {
    const response = await fetch(`${baseApiUrl}${url}`, {
      credentials: 'include',
      ...options,
      headers: {
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
    })
    let data = null
    try {
      data = await response.json()
    } catch {
      data = null
    }
    if (!response.ok) {
      const error = new Error((data && data.error) || 'Anfrage fehlgeschlagen.')
      error.status = response.status
      throw error
    }
    return data
  }

  const impowerBearerHeaders = () => {
    const token = JSON.parse(localStorage.getItem('auth') || '{}').token
    return token
      ? { Authorization: `Bearer ${token}`, Accept: 'application/json' }
      : { Accept: 'application/json' }
  }

  const getEditContactId = () =>
    window.location.pathname.match(/\/edit-person\/(\d+)/)?.[1] ||
    window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1] ||
    null

  const getViewContactId = () =>
    window.location.pathname.match(/\/view-person\/(\d+)/)?.[1] ||
    window.location.pathname.match(/\/persons\/view-person\/(\d+)/)?.[1] ||
    window.location.pathname.match(/\/view-company\/(\d+)/)?.[1] ||
    null

  const notify = (message, type = 'error') => {
    if (typeof showToast === 'function') {
      showToast(message, type)
      return
    }
    console.warn(message)
  }

  const TRASH_ICON_SVG = `
    <span role="img" class="anticon">
      <svg viewBox="0 0 18 21" width="18" height="21" fill="none" aria-hidden="true">
        <path d="M3.26 21H14.74L16 7H2L3.26 21ZM13 4V2C13 1.46957 12.7893 0.960859 12.4142 0.585786C12.0391 0.210714 11.5304 0 11 0H7C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V4H0V6H18V4H13ZM11 4H7V2H11V4Z" fill="currentColor"></path>
      </svg>
    </span>`

  const SAVE_ICON_SVG = `
    <span role="img" class="anticon">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
        <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10v4z"></path>
      </svg>
    </span>`

  // Cancel control in edit/draft rows
  const DISCARD_ICON_SVG = `
    <span role="img" class="anticon">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true">
        <path d="M5 5l14 14M19 5L5 19"></path>
      </svg>
    </span>`

  const EDIT_ICON_SVG = `
    <span role="img" class="anticon">
      <svg viewBox="64 64 896 896" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path>
      </svg>
    </span>`

  const OPTION_CHECK_SVG = `
    <span class="ant-select-item-option-state" unselectable="on" aria-hidden="true">
      <span role="img" class="anticon anticon-check">
        <svg viewBox="64 64 896 896" width="12" height="12" fill="currentColor" aria-hidden="true">
          <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.5 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path>
        </svg>
      </span>
    </span>`

  const UPLOAD_ICON_SVG = `
    <span role="img" class="anticon">
      <svg viewBox="64 64 896 896" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171.9a8 8 0 00-12.6 0l-112 132.9c-4.1 5.2-.4 12.9 6.3 12.9zM878 626h-60c-4.4 0-8 3.6-8 8v210H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v274c0 4.4 3.6 8 8 8h736c4.4 0 8-3.6 8-8V634c0-4.4-3.6-8-8-8z"></path>
      </svg>
    </span>`

  const DOCS_FILE_ICON_SVG = `
    <span role="img" class="anticon impowerx-contact-roles-docs-file-icon" aria-hidden="true">
      <svg viewBox="64 64 896 896" width="14" height="14" fill="currentColor">
        <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"></path>
      </svg>
    </span>`

  const DOCS_ICON_SVG = `
    <span role="img" class="anticon" aria-hidden="true">
      <svg viewBox="64 64 896 896" width="18" height="18" fill="currentColor">
        <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h192a8 8 0 008-8v-48a8 8 0 00-8-8H320z"></path>
      </svg>
    </span>`

  const EYE_ICON_SVG = `
    <span role="img" class="anticon" aria-hidden="true">
      <svg viewBox="64 64 896 896" width="16" height="16" fill="currentColor">
        <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
      </svg>
    </span>`

  const contactCache = new Map()

  const formatContactName = (contact) => {
    if (!contact) return ''
    if (contact.companyName) return contact.companyName
    const parts = [contact.firstName, contact.lastName].filter(Boolean)
    if (parts.length) return parts.join(' ')
    return contact.name || (contact.id ? `Kontakt ${contact.id}` : '')
  }

  const toContactEntry = (contact, fallbackId) => {
    const id = Number(contact?.id ?? fallbackId)
    if (!Number.isInteger(id) || id <= 0) return null
    const existing = contactCache.get(id)
    const entry = {
      id,
      name: formatContactName(contact) || existing?.name || `Kontakt ${id}`,
    }
    contactCache.set(id, entry)
    return entry
  }

  async function searchContacts(query) {
    const params = new URLSearchParams({ size: '25' })
    if (query) params.set('name', query)
    const data = await fetchImpowerJson(
      `/services/pmp-accounting/api/v1/contacts/search?${params.toString()}&types=PERSON,COMPANY,MANAGEMENT_COMPANY`
    )
    const rows = Array.isArray(data?.content)
      ? data.content
      : Array.isArray(data)
        ? data
        : []
    return rows.map((contact) => toContactEntry(contact)).filter(Boolean)
  }

  async function ensureContactCached(contactId) {
    if (!contactId) return null
    const cached = contactCache.get(contactId)
    if (cached?.name && cached.name !== `Kontakt ${contactId}`) return cached

    const detail = await fetchImpowerJson(
      `/services/pmp-accounting/api/v1/contacts/${encodeURIComponent(String(contactId))}`
    )
    if (!detail) {
      return cached || { id: contactId, name: `Kontakt ${contactId}` }
    }
    return toContactEntry(detail, contactId)
  }

  const propertyCache = new Map()
  const buildingsCache = new Map()

  const normalizeBuildings = (raw) => {
    if (!Array.isArray(raw)) return null
    return raw
      .map((building) => ({
        id: Number(building.id),
        name:
          building.name || building.buildingHrId || `Gebäude ${building.id}`,
      }))
      .filter((building) => Number.isInteger(building.id) && building.id > 0)
  }

  /** Prefer a non-empty list; keep explicit empty only when nothing richer is cached. */
  const mergeBuildings = (incomingRaw, existingBuildings) => {
    const incoming = normalizeBuildings(incomingRaw)
    const existing = Array.isArray(existingBuildings) ? existingBuildings : []
    if (incoming?.length) return incoming
    if (existing.length) return existing
    return incoming ?? existing
  }

  /**
   * `properties?propertyId=…` may return a single object, a bare array, or `{ content: [] }`.
   * Normalize to the matching property record (same idea as serial-letter-recipient-report).
   */
  const extractPropertyDetail = (payload, propertyId) => {
    if (payload == null || typeof payload !== 'object') return null
    const candidates = Array.isArray(payload)
      ? payload
      : Array.isArray(payload.content)
        ? payload.content
        : [payload]
    if (!candidates.length) return null
    const id = Number(propertyId)
    const match = candidates.find((row) => Number(row?.id) === id)
    return match || candidates[0] || null
  }

  const toPropertyEntry = (property, fallbackId) => {
    const id = Number(property?.id ?? fallbackId)
    if (!Number.isInteger(id) || id <= 0) return null
    const existing = propertyCache.get(id)
    const entry = {
      id,
      name:
        property?.name ||
        existing?.name ||
        property?.propertyIdInternal ||
        `Objekt ${id}`,
      propertyHrId: String(
        property?.propertyHrId || existing?.propertyHrId || ''
      ).trim(),
      buildings: mergeBuildings(property?.buildings, existing?.buildings),
      fromV1: Boolean(existing?.fromV1),
    }
    propertyCache.set(id, entry)
    if (entry.buildings.length) buildingsCache.set(id, entry.buildings)
    return entry
  }

  const fetchImpowerJson = async (url) => {
    const response = await fetch(url, { headers: impowerBearerHeaders() })
    if (!response.ok) return null
    try {
      return await response.json()
    } catch {
      return null
    }
  }

  async function searchProperties(query) {
    const params = new URLSearchParams({
      states: 'READY',
      page: '0',
      size: '25',
      order: 'ASC',
      sort: 'name',
    })
    if (query) params.set('name', query)
    const data = await fetchImpowerJson(
      `/services/pmp-public/v2/properties?${params.toString()}`
    )
    const rows = Array.isArray(data?.content) ? data.content : []
    return rows.map((property) => toPropertyEntry(property)).filter(Boolean)
  }

  async function ensurePropertyCached(propertyId) {
    if (!propertyId) return null
    const cached = propertyCache.get(propertyId)
    if (cached?.fromV1) return cached

    const payload = await fetchImpowerJson(
      `/services/pmp-accounting/api/v1/properties?propertyId=${encodeURIComponent(String(propertyId))}`
    )
    const detail = extractPropertyDetail(payload, propertyId)
    if (!detail) {
      return (
        cached || {
          id: propertyId,
          name: `Objekt ${propertyId}`,
          propertyHrId: '',
          buildings: [],
          fromV1: false,
        }
      )
    }

    const buildings = normalizeBuildings(detail.buildings)
    const entry = toPropertyEntry(
      {
        ...detail,
        // Only pass buildings when the v1 payload included the field; otherwise keep cache.
        ...(buildings != null ? { buildings } : {}),
      },
      propertyId
    )
    if (!entry) {
      return (
        cached || {
          id: propertyId,
          name: `Objekt ${propertyId}`,
          propertyHrId: '',
          buildings: [],
          fromV1: false,
        }
      )
    }
    // Latch only after a real property record was extracted.
    // Mark fromV1 only when buildings were present on the payload (incl. explicit []).
    if (buildings != null) {
      entry.buildings = buildings
      entry.fromV1 = true
    }
    propertyCache.set(propertyId, entry)
    buildingsCache.set(propertyId, entry.buildings)
    return entry
  }

  async function loadBuildingsForProperty(property) {
    if (!property?.id) return []
    const full = await ensurePropertyCached(property.id)
    return full?.buildings || []
  }

  function formatBuildingsLabel(property, buildingIds) {
    if (!buildingIds?.length) return 'alle Gebäude'
    const byId = new Map(
      (property?.buildings || []).map((building) => [
        building.id,
        building.name,
      ])
    )
    return buildingIds
      .map((id) => byId.get(Number(id)) || String(id))
      .join(', ')
  }

  function sharedBuildingInvoice(buildingInvoices) {
    if (!Array.isArray(buildingInvoices)) return null
    return (
      buildingInvoices.find((entry) => entry && entry.buildingId == null) || null
    )
  }

  function perBuildingInvoices(buildingInvoices) {
    if (!Array.isArray(buildingInvoices)) return []
    return buildingInvoices.filter(
      (entry) => entry && entry.buildingId != null
    )
  }

  function formatCurrencyAmount(value) {
    if (value == null || value === '') return null
    const amount = Number(value)
    if (!Number.isFinite(amount)) return null
    return amount.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
  }

  function formatAssignmentBillingSuffix(assignment, property) {
    if (assignment.kindName !== 'Gewerblich') return ''
    const invoices = assignment.buildingInvoices
    const shared = sharedBuildingInvoice(invoices)
    if (shared) {
      let suffix = ''
      const amount = formatCurrencyAmount(shared.monthlyInvoiceNet)
      if (amount) suffix += ` · ${amount} netto/Monat`
      if (shared.invoiceVat != null)
        suffix += ` · MwSt.-Ausweis: ${shared.invoiceVat ? 'Ja' : 'Nein'}`
      return suffix
    }
    const perBuilding = perBuildingInvoices(invoices)
    if (!perBuilding.length) return ''
    const byId = new Map(
      (property?.buildings || []).map((building) => [
        building.id,
        building.name,
      ])
    )
    return perBuilding
      .map((entry) => {
        const name = byId.get(Number(entry.buildingId)) || String(entry.buildingId)
        const amount = formatCurrencyAmount(entry.monthlyInvoiceNet) || '—'
        const vat =
          entry.invoiceVat == null
            ? ''
            : ` · MwSt. ${entry.invoiceVat ? 'Ja' : 'Nein'}`
        return ` · ${name}: ${amount}${vat}`
      })
      .join('')
  }

  function formatAssignmentLabel(assignment, property) {
    const roleName = assignment.roleName || 'Rolle'
    let kindName = assignment.kindName ? ` · ${assignment.kindName}` : ''
    kindName += formatAssignmentBillingSuffix(assignment, property)
    if (!assignment.propertyId) return `${roleName}${kindName} · alle Objekte`
    const propertyName = property?.name || `Objekt ${assignment.propertyId}`
    const buildingIds = assignment.buildingIds || []
    if (!buildingIds.length)
      return `${roleName}${kindName} · ${propertyName} · alle Gebäude`
    return `${roleName}${kindName} · ${propertyName} · ${formatBuildingsLabel(property, buildingIds)}`
  }

  async function mountContactRolesEditTable(
    host,
    { contactId = null, propertyId = null, roleType = null } = {}
  ) {
    const pageContactId = contactId ? Number(contactId) : null
    const pagePropertyId = propertyId ? Number(propertyId) : null
    const isPropertyMode =
      Number.isInteger(pagePropertyId) && pagePropertyId > 0
    const roleTypeFilter =
      roleType === 'internal' || roleType === 'external' ? roleType : null
    const showKind = roleTypeFilter !== 'internal'
    const matchesRoleType = (row) =>
      !roleTypeFilter || row.roleType === roleTypeFilter
    const propertyAssignmentsUrl = () =>
      `/api/impowerX/properties/${pagePropertyId}/roles${
        roleTypeFilter ? `?type=${encodeURIComponent(roleTypeFilter)}` : ''
      }`
    const state = {
      contactId: pageContactId,
      propertyId: pagePropertyId,
      catalogRoles: [],
      catalogKinds: [],
      assignments: [],
      draftOpen: false,
      editingIndex: null,
      draft: {
        contactId: '',
        contactLabel: '',
        roleId: '',
        kindId: '',
        billingMode: 'total',
        monthlyInvoiceNet: '',
        invoiceVat: null,
        buildingInvoiceDrafts: {},
        buildingsLoaded: false,
        propertyId: isPropertyMode ? pagePropertyId : null,
        propertyLabel: '',
        buildingIds: [],
        buildings: [],
        portal: false,
      },
      saving: false,
      expandedAssignmentIds: new Set(),
      expandedBillingIds: new Set(),
      billingDraftOpen: false,
      docsByAssignmentId: new Map(),
      docsLoadingIds: new Set(),
      editBaseline: null,
    }

    const formColumn = (labelHtml, innerHtml, extraClass = '') => `
      <div class="sub-section-content-column ehv-element ${extraClass}" style="${
        extraClass.includes('impowerx-contact-roles-full')
          ? 'width: 100%; min-width: 0;'
          : 'min-width: 25rem;'
      }">
        <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
          <div class="ant-col ant-form-item-label">${labelHtml}</div>
          <div class="ant-col ant-form-item-control">
            <div class="ant-form-item-control-input">
              <div class="ant-form-item-control-input-content">${innerHtml}</div>
            </div>
          </div>
        </div>
      </div>
    `

    host.innerHTML = `
      <style>
        .impowerx-contact-roles-table {
          width: 100%; max-width: none; min-width: 40rem; border-collapse: collapse; font-size: 14px;
          table-layout: fixed;
          box-sizing: border-box;
        }
        .impowerx-contact-roles-table th,
        .impowerx-contact-roles-table td {
          border-bottom: 1px solid #f0f0f0; padding: 8px 8px 8px 0; text-align: left; vertical-align: middle;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }
        /* Text columns share leftover space. Last two columns (Portal, Actions) are fixed. */
        .impowerx-contact-roles-table th:not(:nth-last-child(-n + 2)),
        .impowerx-contact-roles-table td:not(:nth-last-child(-n + 2)) {
          width: auto;
          max-width: 0;
          min-width: 0;
        }
        .impowerx-contact-roles-table tr[data-roles-editing] td:not(:nth-last-child(-n + 2)),
        .impowerx-contact-roles-table tr[data-roles-draft] td:not(:nth-last-child(-n + 2)) {
          overflow: visible;
          white-space: normal;
          vertical-align: top;
        }
        .impowerx-contact-roles-table tr[data-roles-editing] td:nth-last-child(-n + 2),
        .impowerx-contact-roles-table tr[data-roles-draft] td:nth-last-child(-n + 2) {
          overflow: hidden;
          white-space: nowrap;
          vertical-align: middle;
        }
        .impowerx-contact-roles-full .ant-form-item-control-input,
        .impowerx-contact-roles-full .ant-form-item-control-input-content {
          overflow: visible !important;
        }
        .impowerx-contact-roles-combo { position: relative; width: 100%; }
        .impowerx-contact-roles-combo .ant-select { width: 100%; }
        .impowerx-contact-roles-combo .ant-select-selection-item {
          pointer-events: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .impowerx-contact-roles-combo.is-searching .ant-select-selection-item {
          display: none;
        }
        .impowerx-contact-roles-combo .ant-select-selection-search-input::placeholder,
        .impowerx-contact-roles-combo .ant-select-selection-search-input::-webkit-input-placeholder {
          font-weight: 400;
          color: rgba(0, 0, 0, 0.25);
        }
        .impowerx-contact-roles-combo .ant-select-item-option-disabled {
          color: rgba(0, 0, 0, 0.25); cursor: default;
        }
        .impowerx-contact-roles-combo .ant-select-item-option-selected {
          background: #e6f7ff;
        }
        .impowerx-contact-roles-multi .ant-select-item-option {
          display: flex; align-items: center; justify-content: space-between;
        }
        .impowerx-contact-roles-multi .ant-select-item-option-content {
          flex: 1; min-width: 0;
        }
        .impowerx-contact-roles-combo:not(.impowerx-contact-roles-multi) .ant-select-item-option-state,
        .impowerx-contact-roles-dropdown:not(.impowerx-contact-roles-dropdown--multi) .ant-select-item-option-state {
          display: none;
        }
        .impowerx-contact-roles-multi .ant-select-item-option-state,
        .impowerx-contact-roles-dropdown--multi .ant-select-item-option-state {
          display: none; color: #1890ff; margin-left: 8px; flex-shrink: 0;
        }
        .impowerx-contact-roles-multi .ant-select-item-option-selected .ant-select-item-option-state,
        .impowerx-contact-roles-dropdown--multi .ant-select-item-option-selected .ant-select-item-option-state {
          display: inline-flex; align-items: center;
        }
        .impowerx-contact-roles-dropdown--multi .ant-select-item-option {
          display: flex; align-items: center; justify-content: space-between;
        }
        .impowerx-contact-roles-dropdown--multi .ant-select-item-option-content {
          flex: 1; min-width: 0;
        }
        .impowerx-contact-roles-multi {
          max-width: 100%;
          min-width: 0;
        }
        .impowerx-contact-roles-multi .ant-select {
          max-width: 100%;
        }
        .impowerx-contact-roles-multi .ant-select-selector {
          min-height: 40px; height: auto; display: flex; align-items: center; flex-wrap: wrap;
          gap: 4px; padding: 4px 24px 4px 11px; box-sizing: border-box;
          max-width: 100%;
          overflow: hidden;
        }
        .impowerx-contact-roles-multi-tags {
          display: flex; flex-wrap: wrap; gap: 4px; align-items: center; min-width: 0;
          max-width: 100%;
        }
        .impowerx-contact-roles-multi-tag {
          display: inline-flex; align-items: center; gap: 4px;
          font-size: 12px; line-height: 20px; padding: 0 4px 0 7px;
          background: #f5f5f5; border: 1px solid #e8e8e8; border-radius: 4px;
          color: rgba(0,0,0,0.85); max-width: 100%;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }
        .impowerx-contact-roles-multi-tag-remove {
          border: none; background: transparent; padding: 0; margin: 0;
          cursor: pointer; color: #999; font-size: 14px; line-height: 1;
        }
        .impowerx-contact-roles-multi [data-roles-buildings-placeholder] {
          font-weight: 400; color: rgba(0, 0, 0, 0.25);
        }
        .impowerx-contact-roles-multi [data-roles-buildings-search] {
          width: 100%; border: none; box-shadow: none; outline: none;
          padding: 4px 0; font-size: 14px; background: transparent;
        }
        .impowerx-contact-roles-table th:nth-last-child(2),
        .impowerx-contact-roles-table td:nth-last-child(2) {
          width: 5.5rem !important;
          min-width: 5.5rem !important;
          max-width: 5.5rem !important;
          text-align: center;
          padding: 8px 4px !important;
          overflow: hidden !important;
          white-space: nowrap !important;
          box-sizing: border-box;
        }
        .impowerx-contact-roles-table th:last-child,
        .impowerx-contact-roles-table td:last-child {
          width: 15rem !important;
          min-width: 15rem !important;
          max-width: 15rem !important;
          box-sizing: border-box;
          text-align: right;
          padding: 8px 4px 8px 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: unset;
          position: relative;
          z-index: 2;
        }
        .impowerx-contact-roles-portal {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          cursor: pointer;
          user-select: none;
          vertical-align: middle;
        }
        .impowerx-contact-roles-table tr[data-roles-billing-row][hidden] {
          display: none;
        }
        .impowerx-contact-roles-table .impowerx-contact-roles-toggle-cell {
          width: 2.75rem !important;
          min-width: 2.75rem !important;
          max-width: 2.75rem !important;
          padding: 4px 14px 4px 0 !important;
          overflow: visible !important;
          text-align: left;
          text-overflow: clip;
        }
        .impowerx-contact-roles-table [data-roles-billing-row] > td,
        .impowerx-contact-roles-table .impowerx-contact-roles-docs-subrow > td {
          width: auto !important;
          max-width: none !important;
          min-width: 0 !important;
        }
        .impowerx-contact-roles-table [data-roles-billing-row] > td {
          padding: 2px 8px 12px 4.5rem !important;
          text-align: left;
          white-space: normal !important;
          overflow: visible !important;
        }
        .impowerx-contact-roles-billing-toggle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          margin: 0;
          padding: 0;
          border: 0;
          background: transparent;
          color: rgba(0, 0, 0, 0.45);
          cursor: pointer;
          flex: 0 0 auto;
        }
        .impowerx-contact-roles-billing-toggle:hover {
          color: rgba(0, 0, 0, 0.88);
        }
        .impowerx-contact-roles-billing-chevron {
          display: block;
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          border-left: 5px solid currentColor;
          transition: transform 0.15s ease;
        }
        .impowerx-contact-roles-billing-toggle.is-open .impowerx-contact-roles-billing-chevron {
          transform: rotate(90deg);
        }
        .impowerx-contact-roles-billing,
        .impowerx-contact-roles-billing-field {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          white-space: nowrap;
        }
        .impowerx-contact-roles-billing[hidden] {
          display: none;
        }
        .impowerx-contact-roles-billing {
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;
          padding: 0;
          width: max-content;
          white-space: normal;
        }
        .impowerx-contact-roles-billing-row {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          gap: 32px;
          white-space: nowrap;
        }
        .impowerx-contact-roles-billing-mode {
          display: inline-flex;
          align-items: center;
          gap: 12px;
        }
        .impowerx-contact-roles-billing-mode .ant-radio-group {
          display: inline-flex;
          align-items: center;
          gap: 16px;
        }
        .impowerx-contact-roles-billing-buildings {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .impowerx-contact-roles-billing-building {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          gap: 24px;
          white-space: nowrap;
        }
        .impowerx-contact-roles-billing-building-name {
          min-width: 10rem;
          font-weight: 500;
        }
        .impowerx-contact-roles-billing-field {
          gap: 12px;
          margin: 0;
          flex: 0 0 auto;
        }
        .impowerx-contact-roles-table .impowerx-contact-roles-billing-amount {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          width: 152px;
          min-width: 152px;
          height: 40px;
          padding: 0 12px;
          box-sizing: border-box;
          flex: 0 0 auto;
        }
        .impowerx-contact-roles-table .impowerx-contact-roles-billing-amount > .ant-input {
          flex: 1 1 0;
          width: 100%;
          min-width: 0;
          height: auto;
          min-height: 0;
          padding: 0;
          border: 0;
          border-radius: 0;
          background: transparent;
          box-shadow: none;
          outline: none;
          font: inherit;
          font-variant-numeric: tabular-nums;
          line-height: normal;
          text-align: right;
          text-overflow: clip;
        }
        .impowerx-contact-roles-table .impowerx-contact-roles-billing-amount > .ant-input-suffix {
          flex: 0 0 auto;
          margin: 0;
          line-height: normal;
        }
        .impowerx-contact-roles-billing .ant-radio-group {
          display: inline-flex;
          align-items: center;
          flex-wrap: nowrap;
          gap: 16px;
        }
        .impowerx-contact-roles-billing .ant-radio-wrapper {
          margin: 0;
        }
        .impowerx-contact-roles-portal .ant-checkbox {
          top: 0;
        }
        .impowerx-contact-roles-portal .ant-checkbox-input {
          cursor: pointer;
        }
        .impowerx-contact-roles-portal.ant-checkbox-wrapper-disabled,
        .impowerx-contact-roles-portal.ant-checkbox-wrapper-disabled .ant-checkbox-input {
          cursor: default;
        }
        .impowerx-contact-roles-portal.ant-checkbox-wrapper-disabled {
          opacity: 0.75;
        }
        .impowerx-contact-roles-table td:last-child .impowerx-contact-roles-actions {
          justify-content: flex-end;
          flex-wrap: nowrap;
          max-width: 100%;
        }
        [data-roles-table-host] {
          max-width: 100%;
          overflow-x: auto;
          overflow-y: visible;
          box-sizing: border-box;
        }
        .impowerx-contact-roles-empty { color: rgba(0,0,0,0.45); }
        .impowerx-contact-roles-full {
          flex: 1 1 100%;
          width: 100%;
          min-width: 0 !important;
          max-width: none;
        }
        #ContactRolesSection .impowerx-contact-roles-full {
          padding-left: 12px;
          box-sizing: border-box;
        }
        .impowerx-contact-roles-full .ant-form-item,
        .impowerx-contact-roles-full .ant-form-item-control,
        .impowerx-contact-roles-full .ant-form-item-control-input,
        .impowerx-contact-roles-full .ant-form-item-control-input-content {
          width: 100%;
          max-width: none;
        }
        .impowerx-contact-roles-field {
          width: 100%; min-height: 40px; padding: 6px 11px; border-radius: 6px;
          border: 1px solid #d9d9d9; background: #fff; box-sizing: border-box;
        }
        .impowerx-contact-roles-actions {
          display: inline-flex; align-items: center; justify-content: flex-start; gap: 4px;
          width: auto; box-sizing: border-box;
        }
        .impowerx-contact-roles-actions .ant-btn {
          flex: 0 0 auto;
        }
        .impowerx-contact-roles-actions .ant-btn[disabled],
        .impowerx-contact-roles-actions .ant-btn:disabled {
          opacity: 0.35;
          cursor: not-allowed;
          pointer-events: none;
        }
        .impowerx-contact-roles-docs-icon-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 1.375rem;
          height: 1.375rem;
          line-height: 0;
          transform: translateY(-1px);
        }
        .impowerx-contact-roles-docs-icon-wrap .anticon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 0;
        }
        .impowerx-contact-roles-docs-icon-wrap .anticon > svg {
          display: block;
        }
        .impowerx-contact-roles-doc-count {
          position: absolute;
          top: -8px;
          right: -10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 1rem;
          height: 1rem;
          padding: 0 3px;
          border-radius: 999px;
          background: rgba(0,0,0,0.45);
          color: #fff;
          font-size: 10px;
          font-weight: 600;
          line-height: 1;
          box-sizing: border-box;
          pointer-events: none;
          z-index: 1;
        }
        .impowerx-contact-roles-doc-count[data-empty="true"] {
          display: none;
        }
        .impowerx-contact-roles-actions .ant-btn.impowerx-contact-roles-docs-toggle {
          overflow: visible;
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
        }
        .impowerx-contact-roles-actions .ant-btn[aria-expanded="true"] {
          background: rgba(0,0,0,0.04);
        }
        .impowerx-contact-roles-docs-subrow > td {
          background: #fafafa;
          padding: 6px 8px 10px 1.5rem;
          border-bottom: 1px solid #f0f0f0;
          white-space: normal;
          overflow: visible;
          text-overflow: unset;
        }
        .impowerx-contact-roles-docs-list {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .impowerx-contact-roles-docs-list li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 6px 0;
          border-bottom: 1px solid #f0f0f0;
        }
        .impowerx-contact-roles-docs-list li:last-child {
          border-bottom: none;
        }
        .impowerx-contact-roles-docs-name-wrap {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
          flex: 1 1 auto;
        }
        .impowerx-contact-roles-docs-file-icon {
          flex: 0 0 auto;
          color: rgba(0,0,0,0.45);
          display: inline-flex;
        }
        .impowerx-contact-roles-docs-name {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .impowerx-contact-roles-docs-actions {
          display: flex;
          gap: 4px;
          flex: 0 0 auto;
          align-items: center;
        }
        .impowerx-contact-roles-docs-actions .ant-btn {
          flex: 0 0 auto;
        }
        .impowerx-contact-roles-docs-loading,
        .impowerx-contact-roles-docs-empty {
          color: rgba(0,0,0,0.45);
          padding: 8px 0;
          text-align: center;
        }
        .impowerx-contact-roles-docs-add {
          margin-top: 8px;
        }
        .impowerx-contact-roles-docs-add .anticon {
          display: inline-flex;
          align-items: center;
        }
        .impowerx-contact-roles-docs-dialog-backdrop {
          position: fixed;
          inset: 0;
          z-index: 10050;
          background: rgba(0,0,0,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .impowerx-contact-roles-docs-dialog {
          background: #fff;
          border-radius: 8px;
          min-width: 420px;
          max-width: 560px;
          padding: 20px 24px;
          box-shadow: 0 6px 16px rgba(0,0,0,0.12);
        }
        .impowerx-contact-roles-docs-dialog h3 {
          margin: 0 0 8px;
          font-size: 16px;
          font-weight: 600;
        }
        .impowerx-contact-roles-docs-dialog p {
          margin: 0 0 24px;
          color: rgba(0,0,0,0.65);
          font-size: 14px;
          line-height: 1.5;
        }
        .impowerx-contact-roles-docs-dialog-actions {
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
          justify-content: flex-end;
          align-items: center;
        }
        .impowerx-contact-roles-docs-dialog-actions .ant-btn {
          flex: 0 0 auto;
          white-space: nowrap;
        }
        .impowerx-contact-roles-add-row { margin-top: 4px; }
        .impowerx-contact-roles-property-host { overflow: visible; max-width: 100%; min-width: 0; }
        #ContactRolesSection .section-content,
        #ContactRolesSection .form-section-wrapper { overflow: visible; }
        .lux-internal-contact-roles-host {
          display: contents;
        }
      </style>
      ${
        isPropertyMode && roleTypeFilter === 'external'
          ? `<div class="sub-section-content-row">
        <div class="sub-section-content-column ehv-element impowerx-contact-roles-full" style="width: 100%; min-width: 0;">
          <div data-roles-table-host><div class="impowerx-contact-roles-empty">Lade…</div></div>
          </div>
      </div>`
          : `<div class="sub-section-content-row">
        ${formColumn(
          `<label title=""><span>Rollen</span></label>`,
          `<div data-roles-table-host><div class="impowerx-contact-roles-empty">Lade…</div></div>`,
          'impowerx-contact-roles-full'
        )}
      </div>`
      }
      <div class="sub-section-content-row impowerx-contact-roles-add-row">
        <div class="sub-section-content-column">
          <button type="button" class="ant-btn ant-btn-default Button AdditionalEntityButton" data-roles-add style="width: 100%;">
            <span role="img" class="anticon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="currentColor"></path>
              </svg>
            </span>
            <div class="label">Rolle hinzufügen</div>
          </button>
        </div>
      </div>
    `

    const tableHost = host.querySelector('[data-roles-table-host]')

    const emptyBillingDraft = () => ({
      billingMode: 'total',
      monthlyInvoiceNet: '',
      invoiceVat: null,
      buildingInvoiceDrafts: {},
      buildingsLoaded: false,
    })

    const clearPerBuildingBillingDraft = () => {
      state.draft.billingMode = 'total'
      state.draft.buildingInvoiceDrafts = {}
    }

    const draftBillingFromAssignment = (row) => {
      const invoices = Array.isArray(row?.buildingInvoices)
        ? row.buildingInvoices
        : null
      const perBuilding = perBuildingInvoices(invoices)
      // Per-building amounts only belong to a property-scoped assignment.
      if (perBuilding.length && row?.propertyId) {
        const buildingInvoiceDrafts = {}
        for (const entry of perBuilding) {
          const id = Number(entry.buildingId)
          if (!Number.isInteger(id) || id <= 0) continue
          buildingInvoiceDrafts[id] = {
            monthlyInvoiceNet:
              entry.monthlyInvoiceNet == null ? '' : entry.monthlyInvoiceNet,
            invoiceVat: entry.invoiceVat ?? null,
          }
        }
        return {
          billingMode: 'perBuilding',
          monthlyInvoiceNet: '',
          invoiceVat: null,
          buildingInvoiceDrafts,
          buildingsLoaded: false,
        }
      }
      const shared = sharedBuildingInvoice(invoices)
      return {
        billingMode: 'total',
        monthlyInvoiceNet:
          shared?.monthlyInvoiceNet == null ? '' : shared.monthlyInvoiceNet,
        invoiceVat: shared?.invoiceVat ?? null,
        buildingInvoiceDrafts: {},
        buildingsLoaded: false,
      }
    }

    const resetDraft = () => {
      state.draftOpen = false
      state.editingIndex = null
      state.editBaseline = null
      state.billingDraftOpen = false
      state.draft = {
        contactId: '',
        contactLabel: '',
        roleId: '',
        kindId: '',
        ...emptyBillingDraft(),
        propertyId: isPropertyMode ? pagePropertyId : null,
        propertyLabel: '',
        buildingIds: [],
        buildings: [],
        portal: false,
      }
    }

    const portalCheckboxHtml = (checked, { disabled = false } = {}) => {
      const isChecked = Boolean(checked)
      return `
        <label class="ant-checkbox-wrapper impowerx-contact-roles-portal${
          isChecked ? ' ant-checkbox-wrapper-checked' : ''
        }${disabled ? ' ant-checkbox-wrapper-disabled' : ''}" title="Portal" aria-label="Portal">
          <span class="ant-checkbox${isChecked ? ' ant-checkbox-checked' : ''}${
            disabled ? ' ant-checkbox-disabled' : ''
          }">
            <input type="checkbox" class="ant-checkbox-input" data-roles-portal${
              disabled ? ' disabled' : ''
            }${isChecked ? ' checked' : ''} />
            <span class="ant-checkbox-inner"></span>
          </span>
        </label>`
    }

    const draftIsCommercial = () =>
      roleAllowsKind(state.draft.roleId) &&
      state.catalogKinds.some(
        (kind) =>
          kind.id === Number(state.draft.kindId) && kind.name === 'Gewerblich'
      )

    const parseBillingAmount = (value) => {
      const raw = String(value ?? '').trim()
      if (!raw) return null
      const normalized = /^\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(raw)
        ? raw.replace(/\./g, '').replace(',', '.')
        : raw.replace(',', '.')
      if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return NaN
      const amount = Number(normalized)
      return Number.isFinite(amount) && amount <= Number.MAX_SAFE_INTEGER / 100
        ? amount
        : NaN
    }

    const formatBillingAmount = (value) => {
      const amount = parseBillingAmount(value)
      if (amount == null) return ''
      return Number.isFinite(amount)
        ? amount.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        : String(value)
    }

    const billingToggleHtml = (open) => `
      <button type="button" class="impowerx-contact-roles-billing-toggle${
        open ? ' is-open' : ''
      }" data-roles-billing-toggle aria-expanded="${open ? 'true' : 'false'}" aria-label="${
        open ? 'Rechnungsangaben ausblenden' : 'Rechnungsangaben anzeigen'
      }" title="Rechnungsangaben">
        <span class="impowerx-contact-roles-billing-chevron" aria-hidden="true"></span>
      </button>`

    const setBillingRowOpen = (billingRow, open) => {
      billingRow.hidden = !open
      const toggle = billingRow.previousElementSibling?.querySelector(
        '[data-roles-billing-toggle]'
      )
      if (!toggle) return
      toggle.classList.toggle('is-open', open)
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
      toggle.setAttribute(
        'aria-label',
        open ? 'Rechnungsangaben ausblenden' : 'Rechnungsangaben anzeigen'
      )
    }

    const syncRoleBillingToggle = (tr) => {
      const cell = tr.querySelector('[data-roles-billing-toggle-cell]')
      if (!cell) return
      cell.innerHTML = ''
    }

    const buildingsForBillingScope = () => {
      const selected = (state.draft.buildingIds || [])
        .map(Number)
        .filter((id) => Number.isInteger(id) && id > 0)
      const available = state.draft.buildings || []
      if (selected.length) {
        const byId = new Map(
          available.map((building) => [Number(building.id), building])
        )
        return selected.map(
          (id) => byId.get(id) || { id, name: `Gebäude ${id}` }
        )
      }
      return available
    }

    const showBillingModeSwitch = () => {
      if (!state.draft.propertyId) return false
      return buildingsForBillingScope().length !== 1
    }

    /**
     * Drop stale per-building drafts when there is no property, or only one
     * building remains in scope (edit/save as a shared total then).
     */
    const syncBillingModeToScope = () => {
      if (!state.draft.propertyId) {
        if (
          state.draft.billingMode === 'perBuilding' ||
          Object.keys(state.draft.buildingInvoiceDrafts || {}).length
        ) {
          clearPerBuildingBillingDraft()
        }
        return
      }
      if (state.draft.billingMode !== 'perBuilding') return
      const buildings = buildingsForBillingScope()
      if (
        state.draft.buildingsLoaded &&
        !buildings.length &&
        !(state.draft.buildingIds || []).length
      ) {
        clearPerBuildingBillingDraft()
        return
      }
      if (buildings.length !== 1) return
      const buildingId = Number(buildings[0].id)
      const draft = state.draft.buildingInvoiceDrafts?.[buildingId] || {}
      const totalEmpty =
        (state.draft.monthlyInvoiceNet == null ||
          state.draft.monthlyInvoiceNet === '') &&
        state.draft.invoiceVat == null
      if (totalEmpty) {
        state.draft.monthlyInvoiceNet = draft.monthlyInvoiceNet ?? ''
        state.draft.invoiceVat = draft.invoiceVat ?? null
      }
      state.draft.billingMode = 'total'
    }

    const parseDraftInvoiceEntry = (buildingId, draft) => {
      const amount = parseBillingAmount(draft?.monthlyInvoiceNet)
      if (amount != null && !Number.isFinite(amount)) {
        return { error: true }
      }
      return {
        buildingId: Number(buildingId),
        monthlyInvoiceNet: amount,
        invoiceVat: draft?.invoiceVat ?? null,
      }
    }

    const amountFieldHtml = ({
      editing,
      value,
      ariaLabel,
      dataAttr = 'data-roles-monthly-invoice-net',
      buildingId = null,
    }) => {
      const amount = formatCurrencyAmount(value)
      if (!editing) return `<span>${escapeHtml(amount || '—')}</span>`
      const buildingAttr =
        buildingId != null ? ` data-building-id="${buildingId}"` : ''
      return `<span class="ant-input-affix-wrapper Input impowerx-contact-roles-billing-amount">
        <input class="ant-input" type="text" inputmode="decimal" autocomplete="off" ${dataAttr}${buildingAttr} value="${escapeHtml(formatBillingAmount(value))}" aria-label="${escapeHtml(ariaLabel)}" placeholder="0,00" />
        <span class="ant-input-suffix">€</span>
      </span>`
    }

    const vatFieldHtml = ({
      editing,
      value,
      radioName,
      buildingId = null,
    }) => {
      if (!editing) {
        return `<span>${value == null ? '—' : value ? 'Ja' : 'Nein'}</span>`
      }
      const buildingAttr =
        buildingId != null ? ` data-building-id="${buildingId}"` : ''
      return `<div class="ant-radio-group ant-radio-group-outline RadioGroup justify-content-unset" role="radiogroup" aria-label="Ausweis der Mehrwertsteuer auf der Rechnung">
        ${[true, false]
          .map(
            (option) => `<div class="radio-group-option">
          <label class="ant-radio-wrapper ant-radio-wrapper-in-form-item${value === option ? ' ant-radio-wrapper-checked' : ''}">
            <span class="ant-radio${value === option ? ' ant-radio-checked' : ''}">
              <input type="radio" class="ant-radio-input" name="${radioName}" data-roles-invoice-vat${buildingAttr} value="${option}"${value === option ? ' checked' : ''} />
              <span class="ant-radio-inner"></span>
            </span>
            <span>${option ? 'Ja' : 'Nein'}</span>
          </label>
        </div>`
          )
          .join('')}
      </div>`
    }

    const invoiceFieldsHtml = ({
      editing,
      monthlyInvoiceNet,
      invoiceVat,
      radioName,
      buildingId = null,
      buildingName = null,
    }) => {
      const fields = `
        <label class="impowerx-contact-roles-billing-field">
          <span>Netto-Rechnungsbetrag pro Monat:</span>
          ${amountFieldHtml({
            editing,
            value: monthlyInvoiceNet,
            ariaLabel: buildingName
              ? `Netto-Rechnungsbetrag pro Monat für ${buildingName}`
              : 'Netto-Rechnungsbetrag pro Monat',
            buildingId,
          })}
        </label>
        <div class="impowerx-contact-roles-billing-field">
          <span>Ausweis der Mehrwertsteuer auf der Rechnung:</span>
          ${vatFieldHtml({ editing, value: invoiceVat, radioName, buildingId })}
        </div>`
      if (buildingName == null) {
        return `<div class="impowerx-contact-roles-billing-row">${fields}</div>`
      }
      return `<div class="impowerx-contact-roles-billing-building" data-roles-billing-building="${buildingId}">
        <span class="impowerx-contact-roles-billing-building-name">${escapeHtml(buildingName)}</span>
        ${fields}
      </div>`
    }

    const billingContentHtml = (row, editing = false) => {
      const radioBase = `roles-invoice-vat-${isPropertyMode ? 'property' : 'contact'}-${pagePropertyId || pageContactId}-${roleTypeFilter || 'all'}-${row.id || 'draft'}`
      if (editing) {
        syncBillingModeToScope()
        const buildings = buildingsForBillingScope()
        const showSwitch = showBillingModeSwitch()
        const mode = state.draft.billingMode || 'total'
        const modeSwitch = showSwitch
          ? `<div class="impowerx-contact-roles-billing-mode">
              <span>Betrag:</span>
              <div class="ant-radio-group ant-radio-group-outline RadioGroup justify-content-unset" role="radiogroup" aria-label="Rechnungsbetrag Gesamt oder pro Gebäude">
                ${[
                  ['total', 'Gesamtbetrag'],
                  ['perBuilding', 'Pro Gebäude'],
                ]
                  .map(
                    ([value, label]) => `<div class="radio-group-option">
                  <label class="ant-radio-wrapper ant-radio-wrapper-in-form-item${mode === value ? ' ant-radio-wrapper-checked' : ''}">
                    <span class="ant-radio${mode === value ? ' ant-radio-checked' : ''}">
                      <input type="radio" class="ant-radio-input" name="${radioBase}-mode" data-roles-billing-mode value="${value}"${mode === value ? ' checked' : ''} />
                      <span class="ant-radio-inner"></span>
                    </span>
                    <span>${label}</span>
                  </label>
                </div>`
                  )
                  .join('')}
              </div>
            </div>`
          : ''
        if (mode === 'perBuilding') {
          const rows = buildings.length
            ? buildings
                .map((building) => {
                  const draft =
                    state.draft.buildingInvoiceDrafts?.[building.id] || {}
                  return invoiceFieldsHtml({
                    editing: true,
                    monthlyInvoiceNet: draft.monthlyInvoiceNet ?? '',
                    invoiceVat: draft.invoiceVat ?? null,
                    radioName: `${radioBase}-b${building.id}`,
                    buildingId: building.id,
                    buildingName: building.name || `Gebäude ${building.id}`,
                  })
                })
                .join('')
            : `<div class="impowerx-contact-roles-billing-row">${
                state.draft.buildingsLoaded
                  ? 'Keine Gebäude für Beträge pro Gebäude.'
                  : 'Gebäude werden geladen…'
              }</div>`
          return `${modeSwitch}<div class="impowerx-contact-roles-billing-buildings">${rows}</div>`
        }
        return `${modeSwitch}${invoiceFieldsHtml({
          editing: true,
          monthlyInvoiceNet: state.draft.monthlyInvoiceNet,
          invoiceVat: state.draft.invoiceVat,
          radioName: radioBase,
        })}`
      }

      const invoices = row.buildingInvoices
      const shared = sharedBuildingInvoice(invoices)
      const perBuilding = perBuildingInvoices(invoices)
      if (perBuilding.length) {
        const byId = new Map(
          (row.propertyId
            ? propertyCache.get(row.propertyId)?.buildings || []
            : []
          ).map((building) => [Number(building.id), building.name])
        )
        const rows = perBuilding
          .map((entry) =>
            invoiceFieldsHtml({
              editing: false,
              monthlyInvoiceNet: entry.monthlyInvoiceNet,
              invoiceVat: entry.invoiceVat,
              radioName: radioBase,
              buildingId: entry.buildingId,
              buildingName:
                byId.get(Number(entry.buildingId)) ||
                `Gebäude ${entry.buildingId}`,
            })
          )
          .join('')
        return `<div class="impowerx-contact-roles-billing-buildings">${rows}</div>`
      }
      return invoiceFieldsHtml({
        editing: false,
        monthlyInvoiceNet: shared?.monthlyInvoiceNet,
        invoiceVat: shared?.invoiceVat,
        radioName: radioBase,
      })
    }

    const billingRowHtml = (row, editing = false, open = false) => {
      const assignmentId = row.id ? Number(row.id) : null
      return `<tr data-roles-billing-row${editing ? ' data-roles-billing-draft' : ''}${
        assignmentId ? ` data-assignment-id="${assignmentId}"` : ''
      }${open ? '' : ' hidden'}>
        <td colspan="${showKind ? 7 : 6}">
          <div class="impowerx-contact-roles-billing">
            ${billingContentHtml(row, editing)}
          </div>
        </td></tr>`
    }

    const bindAmountInput = (input, onChange) => {
      const amountWrapper = input.closest('.ant-input-affix-wrapper')
      input.addEventListener('input', () => onChange(input.value))
      input.addEventListener('focus', () => {
        amountWrapper?.classList.add('ant-input-affix-wrapper-focused')
      })
      input.addEventListener('blur', () => {
        amountWrapper?.classList.remove('ant-input-affix-wrapper-focused')
        input.value = formatBillingAmount(input.value)
        onChange(input.value)
      })
    }

    const bindVatInputs = (root, selector, onChange) => {
      root.querySelectorAll(selector).forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return
          onChange(input.value === 'true')
          const group = input.closest('.ant-radio-group')
          group?.querySelectorAll('[data-roles-invoice-vat]').forEach((radio) => {
            radio
              .closest('.ant-radio')
              ?.classList.toggle('ant-radio-checked', radio.checked)
            radio
              .closest('.ant-radio-wrapper')
              ?.classList.toggle('ant-radio-wrapper-checked', radio.checked)
          })
        })
      })
    }

    const ensureBuildingInvoiceDraft = (buildingId) => {
      if (!state.draft.buildingInvoiceDrafts) state.draft.buildingInvoiceDrafts = {}
      if (!state.draft.buildingInvoiceDrafts[buildingId]) {
        state.draft.buildingInvoiceDrafts[buildingId] = {
          monthlyInvoiceNet: '',
          invoiceVat: null,
        }
      }
      return state.draft.buildingInvoiceDrafts[buildingId]
    }

    const refreshBillingEditor = (tr) => {
      if (tr.nextElementSibling?.hasAttribute('data-roles-billing-row'))
        tr.nextElementSibling.remove()
      if (!draftIsCommercial()) {
        state.billingDraftOpen = false
        syncRoleBillingToggle(tr)
        return
      }
      state.billingDraftOpen = true
      tr.insertAdjacentHTML('afterend', billingRowHtml(state.draft, true, true))
      syncRoleBillingToggle(tr)
      const billingRow = tr.nextElementSibling
      billingRow
        .querySelectorAll('[data-roles-billing-mode]')
        .forEach((input) => {
          input.addEventListener('change', () => {
            if (!input.checked) return
            state.draft.billingMode = input.value
            refreshBillingEditor(tr)
          })
        })
      const totalAmount = billingRow.querySelector(
        '[data-roles-monthly-invoice-net]:not([data-building-id])'
      )
      if (totalAmount) {
        bindAmountInput(totalAmount, (value) => {
          state.draft.monthlyInvoiceNet = value
        })
      }
      bindVatInputs(
        billingRow,
        '[data-roles-invoice-vat]:not([data-building-id])',
        (value) => {
          state.draft.invoiceVat = value
        }
      )
      billingRow
        .querySelectorAll('[data-roles-monthly-invoice-net][data-building-id]')
        .forEach((input) => {
          const buildingId = Number(input.getAttribute('data-building-id'))
          bindAmountInput(input, (value) => {
            ensureBuildingInvoiceDraft(buildingId).monthlyInvoiceNet = value
          })
        })
      billingRow
        .querySelectorAll('[data-roles-invoice-vat][data-building-id]')
        .forEach((input) => {
          input.addEventListener('change', () => {
            if (!input.checked) return
            const buildingId = Number(input.getAttribute('data-building-id'))
            ensureBuildingInvoiceDraft(buildingId).invoiceVat =
              input.value === 'true'
            const group = input.closest('.ant-radio-group')
            group
              ?.querySelectorAll('[data-roles-invoice-vat]')
              .forEach((radio) => {
                radio
                  .closest('.ant-radio')
                  ?.classList.toggle('ant-radio-checked', radio.checked)
                radio
                  .closest('.ant-radio-wrapper')
                  ?.classList.toggle(
                    'ant-radio-wrapper-checked',
                    radio.checked
                  )
              })
          })
        })
    }

    const editorActionsHtml = () => `
      <div class="impowerx-contact-roles-actions">
        <button type="button" class="ant-btn ant-btn-ghost Button icon-button" data-roles-cancel title="Abbrechen" aria-label="Bearbeitung verwerfen">
          ${DISCARD_ICON_SVG}
        </button>
        <button type="button" class="ant-btn ant-btn-ghost Button icon-button save" data-roles-save title="Speichern" aria-label="Rolle speichern">
          ${SAVE_ICON_SVG}
        </button>
      </div>
    `

    const editorCellsHtml = () => `
      <td class="impowerx-contact-roles-toggle-cell" data-roles-billing-toggle-cell></td>
      <td>
        ${roleComboHtml()}
      </td>
      ${
        showKind
          ? `<td data-roles-kind-cell>
        ${kindComboHtml()}
      </td>`
          : ''
      }
      <td>
        ${isPropertyMode ? contactComboHtml() : propertyComboHtml()}
      </td>
      <td><div data-roles-buildings></div></td>
      <td>${portalCheckboxHtml(state.draft.portal)}</td>
      <td>
        ${editorActionsHtml()}
      </td>
    `

    const roleOptionsHtml = () => {
      const roles = state.catalogRoles || []
      if (!roles.length) {
        return `<div class="ant-select-item ant-select-item-option ant-select-item-option-disabled" title="Keine Rollen">
          <div class="ant-select-item-option-content"><div class="select-menu-item">Keine Rollen</div></div>
        </div>`
      }
      return roles
        .map(
          (role) =>
            `<div aria-selected="false" class="ant-select-item ant-select-item-option impowerx-select-menu-item" data-role-id="${role.id}" title="${escapeHtml(
              role.name
            )}">
              <div class="ant-select-item-option-content"><div class="select-menu-item">${escapeHtml(
                role.name
              )}</div></div>
        </div>`
        )
        .join('')
    }

    const comboOptionHtml = (
      attrs,
      label,
      selected = false,
      disabled = false
    ) =>
      `<div aria-selected="${selected ? 'true' : 'false'}" class="ant-select-item ant-select-item-option impowerx-select-menu-item${
        selected ? ' ant-select-item-option-selected' : ''
      }${disabled ? ' ant-select-item-option-disabled' : ''}" ${attrs} title="${escapeHtml(label)}">
        <div class="ant-select-item-option-content"><div class="select-menu-item">${escapeHtml(label)}</div></div>
        ${disabled ? '' : OPTION_CHECK_SVG}
      </div>`

    const comboHtml = ({
      comboAttr,
      selectAttr,
      dropdownAttr,
      optionsAttr,
      placeholder,
      optionsInner,
      disabled = false,
    }) => `
      <div class="impowerx-contact-roles-combo" ${comboAttr}>
        <div class="ant-select ant-select-in-form-item Select ant-select-single ant-select-show-arrow ant-select-show-search impowerx-select${
          disabled ? ' read-only ant-select-disabled' : ''
        }" ${selectAttr} style="position: relative; overflow: visible;">
          <div class="ant-select-selector">
            <span class="ant-select-selection-search">
              <input type="search" ${disabled ? 'disabled' : ''} autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-haspopup="listbox" aria-autocomplete="list" value="" placeholder="${placeholder}">
            </span>
            <span class="ant-select-selection-item" title=""></span>
          </div>
          <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
            <span role="img" class="anticon">
              <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
              </svg>
            </span>
          </span>
        </div>
        ${
          disabled
            ? ''
            : `<div style="position: absolute; top: 0; left: 0; width: 100%;" class="dropdown-wrapper">
          <div>
            <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown" ${dropdownAttr} style="z-index: 2000; width: 100%; left: 0; top: 40px;">
              <div>
                <div class="rc-virtual-list" style="position: relative;">
                  <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: auto; overflow-anchor: none;">
                    <div>
                      <div class="rc-virtual-list-holder-inner" style="display: flex; flex-direction: column;" ${optionsAttr}>
                        ${optionsInner}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`
        }
      </div>
    `

    const roleComboHtml = () =>
      comboHtml({
        comboAttr: 'data-roles-role-combo',
        selectAttr: 'data-roles-role-select',
        dropdownAttr: 'data-roles-role-dropdown',
        optionsAttr: 'data-roles-role-options',
        placeholder: 'Bitte wählen…',
        optionsInner: roleOptionsHtml(),
      })

    const kindOptionsHtml = () => {
      const kinds = state.catalogKinds || []
      const selectedId = state.draft.kindId
      const rows = [comboOptionHtml('data-kind-id=""', '—', !selectedId)]
      kinds.forEach((kind) => {
        rows.push(
          comboOptionHtml(
            `data-kind-id="${kind.id}"`,
            kind.name,
            Number(selectedId) === kind.id
          )
        )
      })
      return rows.join('')
    }

    const roleAllowsKind = (roleId = state.draft.roleId) => {
      const role = (state.catalogRoles || []).find(
        (item) => item.id === Number(roleId)
      )
      return Boolean(role?.kindSelectable)
    }

    const kindComboHtml = () => {
      const enabled = roleAllowsKind()
      return comboHtml({
        comboAttr: 'data-roles-kind-combo',
        selectAttr: 'data-roles-kind-select',
        dropdownAttr: 'data-roles-kind-dropdown',
        optionsAttr: 'data-roles-kind-options',
        placeholder: '—',
        optionsInner: kindOptionsHtml(),
        disabled: !enabled,
      })
    }

    const propertyComboHtml = () =>
      comboHtml({
        comboAttr: 'data-roles-property-combo',
        selectAttr: 'data-roles-property-select',
        dropdownAttr: 'data-roles-property-dropdown',
        optionsAttr: 'data-roles-property-options',
        placeholder: 'alle Objekte',
        optionsInner: comboOptionHtml(
          'data-property-id=""',
          'alle Objekte',
          true
        ),
      })

    const contactComboHtml = () =>
      comboHtml({
        comboAttr: 'data-roles-contact-combo',
        selectAttr: 'data-roles-contact-select',
        dropdownAttr: 'data-roles-contact-dropdown',
        optionsAttr: 'data-roles-contact-options',
        placeholder: 'Kontakt wählen…',
        optionsInner: comboOptionHtml('', 'Kontakt suchen…', false, true),
      })

    const buildingsMultiHtml = ({
      disabled = false,
      placeholder = 'alle Gebäude',
      buildings = [],
      selectedIds = [],
    } = {}) => {
      const selected = new Set((selectedIds || []).map(String))
      const optionsInner = buildings.length
        ? buildings
            .map((building) =>
              comboOptionHtml(
                `data-building-id="${building.id}" data-label="${escapeHtml(building.name)}"`,
                building.name,
                selected.has(String(building.id)),
                false
              )
            )
            .join('')
        : comboOptionHtml('', 'Keine Gebäude', false, true)
      return `
        <div class="impowerx-contact-roles-combo impowerx-contact-roles-multi" data-roles-buildings-combo>
          <div class="ant-select ant-select-in-form-item Select ant-select-multiple ant-select-show-arrow ant-select-show-search impowerx-select${
            disabled ? ' read-only ant-select-disabled' : ''
          }" data-roles-buildings-select style="position: relative; overflow: visible; min-height: 40px;">
            <div class="ant-select-selector">
              <span class="ant-select-selection-placeholder" data-roles-buildings-placeholder>${placeholder}</span>
              <span class="impowerx-contact-roles-multi-tags" data-roles-buildings-tags></span>
            </div>
            <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
              <span role="img" class="anticon">
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="#000000"></path>
                </svg>
              </span>
            </span>
          </div>
          ${
            disabled
              ? ''
              : `<div style="position: absolute; top: 0; left: 0; width: 100%;" class="dropdown-wrapper">
            <div>
              <div class="ant-select-dropdown ant-select-dropdown-placement-bottomRight ant-select-dropdown-hidden impowerx-select-dropdown" data-roles-buildings-dropdown style="z-index: 2000; width: 100%; left: 0; top: 40px;">
                <div style="padding: 8px 11px; border-bottom: 1px solid #f0f0f0;">
                  <input type="search" data-roles-buildings-search placeholder="Suchen…" autocomplete="off" />
                </div>
                <div class="rc-virtual-list" style="position: relative;">
                  <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: auto; overflow-anchor: none;">
                    <div>
                      <div class="rc-virtual-list-holder-inner" style="display: flex; flex-direction: column;" data-roles-buildings-options>
                        ${optionsInner}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>`
          }
        </div>
      `
    }

    const COMBO_DROPDOWN_SELECTOR =
      '[data-roles-role-dropdown], [data-roles-kind-dropdown], [data-roles-property-dropdown], [data-roles-contact-dropdown], [data-roles-buildings-dropdown]'

    const hideComboDropdown = (el) => {
      if (!el) return
      el.classList.add('ant-select-dropdown-hidden')
      el.style.position = ''
      el.style.left = ''
      el.style.top = ''
      el.style.bottom = ''
      el.style.width = ''
      el.style.zIndex = ''
      el.style.maxHeight = ''
      el.style.overflowY = ''
      if (el._comboReposition) {
        window.removeEventListener('scroll', el._comboReposition, true)
        window.removeEventListener('resize', el._comboReposition)
        el._comboReposition = null
      }
      if (el._comboAnchorParent && el.parentElement !== el._comboAnchorParent) {
        el._comboAnchorParent.appendChild(el)
      }
    }

    const positionComboDropdown = (selectRoot, dropdown) => {
      const rect = selectRoot.getBoundingClientRect()
      const gap = 4
      const maxH = 256
      const spaceBelow = window.innerHeight - rect.bottom - gap
      const spaceAbove = rect.top - gap
      const openUp = spaceBelow < Math.min(maxH, 160) && spaceAbove > spaceBelow
      const height = Math.max(
        120,
        Math.min(maxH, openUp ? spaceAbove : spaceBelow)
      )

      dropdown.style.position = 'fixed'
      dropdown.style.left = `${Math.max(8, Math.min(rect.left, window.innerWidth - rect.width - 8))}px`
      dropdown.style.width = `${Math.max(rect.width, 120)}px`
      dropdown.style.zIndex = '10060'
      dropdown.style.maxHeight = `${height}px`
      dropdown.style.overflowY = 'auto'
      if (openUp) {
        dropdown.style.top = 'auto'
        dropdown.style.bottom = `${window.innerHeight - rect.top + gap}px`
      } else {
        dropdown.style.bottom = 'auto'
        dropdown.style.top = `${rect.bottom + gap}px`
      }
    }

    const openComboDropdown = (dropdown, selectRoot) => {
      if (!dropdown || !selectRoot) return
      if (!dropdown._comboAnchorParent) {
        dropdown._comboAnchorParent = dropdown.parentElement
      }
      dropdown._comboRoot = selectRoot.closest('.impowerx-contact-roles-combo')
      const isMulti = Boolean(
        selectRoot.closest('.impowerx-contact-roles-multi')
      )
      dropdown.classList.add('impowerx-contact-roles-dropdown')
      dropdown.classList.toggle(
        'impowerx-contact-roles-dropdown--multi',
        isMulti
      )
      if (dropdown.parentElement !== document.body) {
        document.body.appendChild(dropdown)
      }
      if (!dropdown._comboClickGuard) {
        dropdown._comboClickGuard = true
        dropdown.addEventListener('mousedown', (event) =>
          event.stopPropagation()
        )
        dropdown.addEventListener('click', (event) => event.stopPropagation())
      }
      dropdown.classList.remove('ant-select-dropdown-hidden')
      positionComboDropdown(selectRoot, dropdown)
      if (!dropdown._comboReposition) {
        dropdown._comboReposition = () => {
          if (dropdown.classList.contains('ant-select-dropdown-hidden')) return
          if (!document.body.contains(selectRoot)) {
            hideComboDropdown(dropdown)
            return
          }
          positionComboDropdown(selectRoot, dropdown)
        }
        window.addEventListener('scroll', dropdown._comboReposition, true)
        window.addEventListener('resize', dropdown._comboReposition)
      }
    }

    const closeComboDropdowns = (except) => {
      const nodes = [
        ...host.querySelectorAll(COMBO_DROPDOWN_SELECTOR),
        ...document.body.querySelectorAll(COMBO_DROPDOWN_SELECTOR),
      ]
      const seen = new Set()
      nodes.forEach((el) => {
        if (seen.has(el) || el === except) return
        seen.add(el)
        if (!el.classList.contains('ant-select-dropdown-hidden')) {
          hideComboDropdown(el)
          el._comboRoot?.dispatchEvent(new CustomEvent('lux-restore-display'))
        }
      })
    }

    const bindRoleCombo = (tr) => {
      const combo = tr.querySelector('[data-roles-role-combo]')
      const selectRoot = tr.querySelector('[data-roles-role-select]')
      const dropdown = tr.querySelector('[data-roles-role-dropdown]')
      const optionsList = tr.querySelector('[data-roles-role-options]')
      const searchInput = selectRoot?.querySelector(
        '.ant-select-selection-search-input'
      )
      const selectionItem = selectRoot?.querySelector(
        '.ant-select-selection-item'
      )
      if (
        !combo ||
        !selectRoot ||
        !dropdown ||
        !optionsList ||
        !searchInput ||
        !selectionItem
      )
        return

      const defaultPlaceholder = 'Bitte wählen…'

      const selectedLabel = () => {
        const role = (state.catalogRoles || []).find(
          (item) => item.id === Number(state.draft.roleId)
        )
        return role?.name || ''
      }

      const restoreDisplay = () => {
        const label = selectedLabel()
        combo.classList.remove('is-searching')
        selectionItem.textContent = label
        selectionItem.setAttribute('title', label)
        searchInput.value = ''
        searchInput.placeholder = label ? '' : defaultPlaceholder
      }

      const hideSelectedLabel = () => {
        const prev = selectionItem.textContent.trim() || selectedLabel()
        combo.classList.add('is-searching')
        selectionItem.textContent = ''
        selectionItem.setAttribute('title', '')
        if (!searchInput.placeholder)
          searchInput.placeholder = prev || defaultPlaceholder
      }

      const beginSearch = () => {
        hideSelectedLabel()
        const prev = selectedLabel()
        searchInput.value = ''
        searchInput.placeholder = prev || defaultPlaceholder
      }

      const filterOptions = () => {
        const query = searchInput.value.trim().toLowerCase()
        optionsList.querySelectorAll('[data-role-id]').forEach((el) => {
          const label = (el.getAttribute('title') || '').toLowerCase()
          el.style.display = !query || label.includes(query) ? '' : 'none'
        })
      }

      const applySelection = (
        roleId,
        roleName,
        { refreshKind = true } = {}
      ) => {
        const valid = Number.isInteger(roleId) && roleId > 0
        state.draft.roleId = valid ? roleId : ''
        selectRoot.dataset.selectedValue = valid ? String(roleId) : ''
        optionsList.querySelectorAll('[data-role-id]').forEach((el) => {
          const selected =
            valid && String(el.getAttribute('data-role-id')) === String(roleId)
          el.classList.toggle('ant-select-item-option-selected', selected)
          el.setAttribute('aria-selected', selected ? 'true' : 'false')
        })
        restoreDisplay()
        filterOptions()
        if (!refreshKind) return
        if (!roleAllowsKind(valid ? roleId : '')) state.draft.kindId = ''
        const kindCell = tr.querySelector('[data-roles-kind-cell]')
        if (kindCell) {
          kindCell.innerHTML = kindComboHtml()
          bindKindCombo(tr)
        }
        refreshBillingEditor(tr)
      }

      if (state.draft.roleId) {
        const role = (state.catalogRoles || []).find(
          (item) => item.id === Number(state.draft.roleId)
        )
        applySelection(Number(state.draft.roleId), role?.name || '', {
          refreshKind: false,
        })
      }

      combo.addEventListener('lux-restore-display', restoreDisplay)

      selectRoot.addEventListener('click', (event) => {
        event.stopPropagation()
        const wasHidden = dropdown.classList.contains(
          'ant-select-dropdown-hidden'
        )
        closeComboDropdowns(dropdown)
        if (wasHidden) {
          openComboDropdown(dropdown, selectRoot)
          beginSearch()
          searchInput.focus()
        } else if (
          !event.target.closest('.ant-select-selection-search-input')
        ) {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      searchInput.addEventListener('input', () => {
        hideSelectedLabel()
        filterOptions()
      })
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      optionsList.addEventListener('mousedown', (event) => {
        const option = event.target.closest('[data-role-id]')
        if (!option) return
        event.preventDefault()
        event.stopPropagation()
        applySelection(
          Number(option.getAttribute('data-role-id')),
          option.getAttribute('title') || ''
        )
        hideComboDropdown(dropdown)
      })
      optionsList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-role-id]')
        if (!option) return
        event.stopPropagation()
        applySelection(
          Number(option.getAttribute('data-role-id')),
          option.getAttribute('title') || ''
        )
        hideComboDropdown(dropdown)
      })

      searchInput.focus()
    }

    const bindKindCombo = (tr) => {
      const combo = tr.querySelector('[data-roles-kind-combo]')
      const selectRoot = tr.querySelector('[data-roles-kind-select]')
      const dropdown = tr.querySelector('[data-roles-kind-dropdown]')
      const optionsList = tr.querySelector('[data-roles-kind-options]')
      const searchInput = selectRoot?.querySelector(
        '.ant-select-selection-search-input'
      )
      const selectionItem = selectRoot?.querySelector(
        '.ant-select-selection-item'
      )
      if (
        !combo ||
        !selectRoot ||
        !dropdown ||
        !optionsList ||
        !searchInput ||
        !selectionItem
      )
        return

      const defaultPlaceholder = '—'

      const selectedLabel = () => {
        const kind = (state.catalogKinds || []).find(
          (item) => item.id === Number(state.draft.kindId)
        )
        return kind?.name || ''
      }

      const restoreDisplay = () => {
        const label = selectedLabel()
        combo.classList.remove('is-searching')
        selectionItem.textContent = label
        selectionItem.setAttribute('title', label)
        searchInput.value = ''
        searchInput.placeholder = label ? '' : defaultPlaceholder
      }

      const hideSelectedLabel = () => {
        const prev = selectionItem.textContent.trim() || selectedLabel()
        combo.classList.add('is-searching')
        selectionItem.textContent = ''
        selectionItem.setAttribute('title', '')
        if (!searchInput.placeholder)
          searchInput.placeholder = prev || defaultPlaceholder
      }

      const beginSearch = () => {
        hideSelectedLabel()
        const prev = selectedLabel()
        searchInput.value = ''
        searchInput.placeholder = prev || defaultPlaceholder
      }

      const filterOptions = () => {
        const query = searchInput.value.trim().toLowerCase()
        optionsList.querySelectorAll('[data-kind-id]').forEach((el) => {
          const label = (el.getAttribute('title') || '').toLowerCase()
          el.style.display = !query || label.includes(query) ? '' : 'none'
        })
      }

      const applySelection = (kindId) => {
        const valid = Number.isInteger(kindId) && kindId > 0
        state.draft.kindId = valid ? kindId : ''
        selectRoot.dataset.selectedValue = valid ? String(kindId) : ''
        optionsList.querySelectorAll('[data-kind-id]').forEach((el) => {
          const selected = valid
            ? String(el.getAttribute('data-kind-id')) === String(kindId)
            : el.getAttribute('data-kind-id') === ''
          el.classList.toggle('ant-select-item-option-selected', selected)
          el.setAttribute('aria-selected', selected ? 'true' : 'false')
        })
        restoreDisplay()
        filterOptions()
        refreshBillingEditor(tr)
      }

      applySelection(state.draft.kindId ? Number(state.draft.kindId) : null)

      combo.addEventListener('lux-restore-display', restoreDisplay)

      selectRoot.addEventListener('click', (event) => {
        event.stopPropagation()
        const wasHidden = dropdown.classList.contains(
          'ant-select-dropdown-hidden'
        )
        closeComboDropdowns(dropdown)
        if (wasHidden) {
          openComboDropdown(dropdown, selectRoot)
          beginSearch()
          searchInput.focus()
        } else if (
          !event.target.closest('.ant-select-selection-search-input')
        ) {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      searchInput.addEventListener('input', () => {
        hideSelectedLabel()
        filterOptions()
      })
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      optionsList.addEventListener('mousedown', (event) => {
        const option = event.target.closest('[data-kind-id]')
        if (!option) return
        event.preventDefault()
        event.stopPropagation()
        const raw = option.getAttribute('data-kind-id')
        applySelection(raw ? Number(raw) : null)
        hideComboDropdown(dropdown)
      })
      optionsList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-kind-id]')
        if (!option) return
        event.stopPropagation()
        const raw = option.getAttribute('data-kind-id')
        applySelection(raw ? Number(raw) : null)
        hideComboDropdown(dropdown)
      })
    }

    const bindPropertyCombo = (tr, buildingsHost) => {
      const combo = tr.querySelector('[data-roles-property-combo]')
      const selectRoot = tr.querySelector('[data-roles-property-select]')
      const dropdown = tr.querySelector('[data-roles-property-dropdown]')
      const optionsList = tr.querySelector('[data-roles-property-options]')
      const searchInput = selectRoot?.querySelector(
        '.ant-select-selection-search-input'
      )
      const selectionItem = selectRoot?.querySelector(
        '.ant-select-selection-item'
      )
      if (
        !combo ||
        !selectRoot ||
        !dropdown ||
        !optionsList ||
        !searchInput ||
        !selectionItem
      )
        return

      let searchTimer = null
      let searchSeq = 0
      let suppressSelectToggle = false
      let picking = false
      const defaultPlaceholder = 'alle Objekte'

      const selectedLabel = () => {
        if (!state.draft.propertyId) return ''
        const cached = propertyCache.get(state.draft.propertyId)
        return (
          state.draft.propertyLabel ||
          cached?.name ||
          `Objekt ${state.draft.propertyId}`
        )
      }

      const restoreDisplay = () => {
        const valid =
          Number.isInteger(state.draft.propertyId) && state.draft.propertyId > 0
        const label = valid ? selectedLabel() : ''
        combo.classList.remove('is-searching')
        selectionItem.textContent = label
        selectionItem.setAttribute('title', label)
        searchInput.value = ''
        searchInput.placeholder = label ? '' : defaultPlaceholder
      }

      const hideSelectedLabel = () => {
        const prev =
          selectionItem.textContent.trim() ||
          selectedLabel() ||
          defaultPlaceholder
        combo.classList.add('is-searching')
        selectionItem.textContent = ''
        selectionItem.setAttribute('title', '')
        if (!searchInput.placeholder) searchInput.placeholder = prev
      }

      const beginSearch = () => {
        hideSelectedLabel()
        searchInput.value = ''
        searchInput.placeholder = selectedLabel() || defaultPlaceholder
      }

      const setDisplay = (propertyId, propertyName) => {
        const valid = Number.isInteger(propertyId) && propertyId > 0
        selectRoot.dataset.selectedValue = valid ? String(propertyId) : ''
        restoreDisplay()
      }

      const renderOptions = (properties) => {
        const selectedId = state.draft.propertyId
        const rows = [
          comboOptionHtml('data-property-id=""', 'alle Objekte', !selectedId),
        ]
        ;(properties || []).forEach((property) => {
          rows.push(
            comboOptionHtml(
              `data-property-id="${property.id}"`,
              property.name,
              selectedId === property.id
            )
          )
        })
        if (!(properties || []).length) {
          rows.push(comboOptionHtml('', 'Keine Objekte gefunden', false, true))
        }
        optionsList.innerHTML = rows.join('')
      }

      const runSearch = async (query) => {
        const seq = ++searchSeq
        const properties = await searchProperties(query)
        if (seq !== searchSeq) return
        renderOptions(properties)
      }

      if (state.draft.propertyId) {
        const cached = propertyCache.get(state.draft.propertyId)
        setDisplay(
          state.draft.propertyId,
          state.draft.propertyLabel ||
            cached?.name ||
            `Objekt ${state.draft.propertyId}`
        )
      } else {
        setDisplay(null, '')
      }

      combo.addEventListener('lux-restore-display', restoreDisplay)

      selectRoot.addEventListener('click', (event) => {
        event.stopPropagation()
        if (suppressSelectToggle) {
          suppressSelectToggle = false
          return
        }
        const wasHidden = dropdown.classList.contains(
          'ant-select-dropdown-hidden'
        )
        closeComboDropdowns(dropdown)
        if (wasHidden) {
          openComboDropdown(dropdown, selectRoot)
          beginSearch()
          searchInput.focus()
          runSearch(searchInput.value.trim())
        } else if (
          !event.target.closest('.ant-select-selection-search-input')
        ) {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      searchInput.addEventListener('input', () => {
        hideSelectedLabel()
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => runSearch(searchInput.value.trim()), 250)
      })
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      const pickPropertyOption = async (option) => {
        if (
          !option ||
          option.classList.contains('ant-select-item-option-disabled') ||
          picking
        )
          return
        picking = true
        suppressSelectToggle = true
        try {
          const raw = option.getAttribute('data-property-id')
          const propertyId = raw ? Number(raw) : null
          const propertyName = option.getAttribute('title') || ''
          const nextId =
            Number.isInteger(propertyId) && propertyId > 0 ? propertyId : null
          const same = nextId === state.draft.propertyId
          state.draft.propertyId = nextId
          state.draft.propertyLabel = nextId ? propertyName : ''
          if (!same) {
            state.draft.buildingIds = []
            state.draft.buildings = []
            state.draft.buildingsLoaded = false
            clearPerBuildingBillingDraft()
          }
          setDisplay(nextId, propertyName)
          hideComboDropdown(dropdown)
          await renderBuildingsInto(buildingsHost)
          const editingRow =
            buildingsHost?.closest('tr') ||
            tableHost.querySelector('[data-roles-editing]')
          if (editingRow) refreshBillingEditor(editingRow)
        } finally {
          picking = false
        }
      }

      optionsList.addEventListener('mousedown', (event) => {
        const option = event.target.closest('[data-property-id]')
        if (
          !option ||
          option.classList.contains('ant-select-item-option-disabled')
        )
          return
        event.preventDefault()
        event.stopPropagation()
        pickPropertyOption(option)
      })
      optionsList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-property-id]')
        if (!option) return
        event.stopPropagation()
        pickPropertyOption(option)
      })
    }

    const bindContactCombo = (tr) => {
      const combo = tr.querySelector('[data-roles-contact-combo]')
      const selectRoot = tr.querySelector('[data-roles-contact-select]')
      const dropdown = tr.querySelector('[data-roles-contact-dropdown]')
      const optionsList = tr.querySelector('[data-roles-contact-options]')
      const searchInput = selectRoot?.querySelector(
        '.ant-select-selection-search-input'
      )
      const selectionItem = selectRoot?.querySelector(
        '.ant-select-selection-item'
      )
      if (
        !combo ||
        !selectRoot ||
        !dropdown ||
        !optionsList ||
        !searchInput ||
        !selectionItem
      )
        return

      let searchTimer = null
      let searchSeq = 0
      const defaultPlaceholder = 'Kontakt wählen…'

      const selectedLabel = () => {
        if (!state.draft.contactId) return ''
        const cached = contactCache.get(state.draft.contactId)
        return (
          state.draft.contactLabel ||
          cached?.name ||
          `Kontakt ${state.draft.contactId}`
        )
      }

      const restoreDisplay = () => {
        const valid =
          Number.isInteger(state.draft.contactId) && state.draft.contactId > 0
        const label = valid ? selectedLabel() : ''
        combo.classList.remove('is-searching')
        selectionItem.textContent = label
        selectionItem.setAttribute('title', label)
        searchInput.value = ''
        searchInput.placeholder = label ? '' : defaultPlaceholder
      }

      const hideSelectedLabel = () => {
        const prev =
          selectionItem.textContent.trim() ||
          selectedLabel() ||
          defaultPlaceholder
        combo.classList.add('is-searching')
        selectionItem.textContent = ''
        selectionItem.setAttribute('title', '')
        if (!searchInput.placeholder) searchInput.placeholder = prev
      }

      const beginSearch = () => {
        hideSelectedLabel()
        searchInput.value = ''
        searchInput.placeholder = selectedLabel() || defaultPlaceholder
      }

      const renderOptions = (contacts) => {
        const selectedId = state.draft.contactId
        const rows = []
        ;(contacts || []).forEach((contact) => {
          rows.push(
            comboOptionHtml(
              `data-contact-id="${contact.id}"`,
              contact.name,
              selectedId === contact.id
            )
          )
        })
        if (!(contacts || []).length) {
          rows.push(comboOptionHtml('', 'Keine Kontakte gefunden', false, true))
        }
        optionsList.innerHTML = rows.join('')
      }

      const runSearch = async (query) => {
        const seq = ++searchSeq
        const contacts = await searchContacts(query)
        if (seq !== searchSeq) return
        renderOptions(contacts)
      }

      if (state.draft.contactId) {
        restoreDisplay()
      } else {
        restoreDisplay()
      }

      combo.addEventListener('lux-restore-display', restoreDisplay)

      selectRoot.addEventListener('click', (event) => {
        event.stopPropagation()
        const wasHidden = dropdown.classList.contains(
          'ant-select-dropdown-hidden'
        )
        closeComboDropdowns(dropdown)
        if (wasHidden) {
          openComboDropdown(dropdown, selectRoot)
          beginSearch()
          searchInput.focus()
          runSearch(searchInput.value.trim())
        } else if (
          !event.target.closest('.ant-select-selection-search-input')
        ) {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      searchInput.addEventListener('input', () => {
        hideSelectedLabel()
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => runSearch(searchInput.value.trim()), 250)
      })
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideComboDropdown(dropdown)
          restoreDisplay()
        }
      })

      const pickContactOption = (option) => {
        if (
          !option ||
          option.classList.contains('ant-select-item-option-disabled')
        )
          return
        const raw = option.getAttribute('data-contact-id')
        const contactId = raw ? Number(raw) : null
        const contactName = option.getAttribute('title') || ''
        const nextId =
          Number.isInteger(contactId) && contactId > 0 ? contactId : null
        state.draft.contactId = nextId
        state.draft.contactLabel = nextId ? contactName : ''
        if (nextId) toContactEntry({ id: nextId, name: contactName }, nextId)
        restoreDisplay()
        hideComboDropdown(dropdown)
      }

      optionsList.addEventListener('mousedown', (event) => {
        const option = event.target.closest('[data-contact-id]')
        if (
          !option ||
          option.classList.contains('ant-select-item-option-disabled')
        )
          return
        event.preventDefault()
        event.stopPropagation()
        pickContactOption(option)
      })
      optionsList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-contact-id]')
        if (!option) return
        event.stopPropagation()
        pickContactOption(option)
      })
    }

    const assignmentRowsHtml = () =>
      state.assignments
        .map((row, index) => {
          if (state.editingIndex === index) {
            return `
            <tr data-assignment-index="${index}" data-roles-editing="true">
              ${editorCellsHtml()}
            </tr>`
          }
          const property = row.propertyId
            ? propertyCache.get(row.propertyId)
            : null
          const contact = row.contactId ? contactCache.get(row.contactId) : null
          const buildingsLabel = !row.propertyId
            ? '—'
            : formatBuildingsLabel(property, row.buildingIds)
          const middleLabel = isPropertyMode
            ? contact?.name ||
              row.contactName ||
              (row.contactId ? `Kontakt ${row.contactId}` : '—')
            : property?.name ||
              (row.propertyId ? `Objekt ${row.propertyId}` : 'alle Objekte')
          const documentCount = Number(row.documentCount) || 0
          const assignmentId = row.id ? Number(row.id) : null
          const isExpanded =
            assignmentId != null &&
            state.expandedAssignmentIds.has(assignmentId)
          const colSpan = showKind ? 7 : 6
          const docsTitle = isExpanded
            ? 'Dokumente ausblenden'
            : `Dokumente ${documentCount === 1 ? 'anzeigen' : `(${documentCount}) anzeigen`}`
          const billingOpen =
            row.kindName === 'Gewerblich' &&
            row.id != null &&
            state.expandedBillingIds.has(Number(row.id))
          const parentRow = `
            <tr data-assignment-index="${index}" data-assignment-id="${row.id || ''}">
              <td class="impowerx-contact-roles-toggle-cell">${
                row.kindName === 'Gewerblich'
                  ? billingToggleHtml(billingOpen)
                  : ''
              }</td>
              <td>${escapeHtml(row.roleName || '')}</td>
              ${showKind ? `<td>${escapeHtml(row.kindName || '—')}</td>` : ''}
              <td title="${escapeHtml(middleLabel)}">${escapeHtml(middleLabel)}</td>
              <td title="${escapeHtml(buildingsLabel)}">${escapeHtml(buildingsLabel)}</td>
              <td>${portalCheckboxHtml(row.portal, { disabled: true })}</td>
              <td>
                <div class="impowerx-contact-roles-actions">
                  ${
                    row.id
                      ? `<button type="button" class="ant-btn ant-btn-ghost Button icon-button impowerx-contact-roles-docs-toggle" data-roles-docs-list title="${docsTitle}" aria-label="${docsTitle}" aria-expanded="${
                          isExpanded ? 'true' : 'false'
                        }">
                    <span class="impowerx-contact-roles-docs-icon-wrap">
                      ${DOCS_ICON_SVG}
                      <span class="impowerx-contact-roles-doc-count"${
                        documentCount < 1 ? ' data-empty="true"' : ''
                      }>${documentCount > 99 ? '99+' : documentCount}</span>
                    </span>
                  </button>`
                      : ''
                  }
                  <button type="button" class="ant-btn ant-btn-ghost Button icon-button trash" data-roles-remove title="Entfernen" aria-label="Zuweisung entfernen">
                    ${TRASH_ICON_SVG}
                  </button>
                  <button type="button" class="ant-btn ant-btn-ghost Button icon-button" data-roles-edit title="Bearbeiten" aria-label="Zuweisung bearbeiten">
                    ${EDIT_ICON_SVG}
                  </button>
                </div>
              </td>
            </tr>${
              row.kindName === 'Gewerblich'
                ? billingRowHtml(row, false, billingOpen)
                : ''
            }`
          if (!isExpanded || !assignmentId) return parentRow
          const isLoading = state.docsLoadingIds.has(assignmentId)
          const docs = state.docsByAssignmentId.get(assignmentId)
          let docsBody = ''
          if (isLoading || docs == null) {
            docsBody =
              '<div class="impowerx-contact-roles-docs-loading">Dokumente werden geladen…</div>'
          } else if (!docs.length) {
            docsBody =
              '<div class="impowerx-contact-roles-docs-empty">Noch keine Dokumente.</div>'
          } else {
            docsBody = `<ul class="impowerx-contact-roles-docs-list">${docs
              .map(
                (doc) => `
              <li>
                <span class="impowerx-contact-roles-docs-name-wrap">
                  ${DOCS_FILE_ICON_SVG}
                  <span class="impowerx-contact-roles-docs-name" title="${escapeHtml(doc.name || `Dokument ${doc.id}`)}">${escapeHtml(
                    doc.name || `Dokument ${doc.id}`
                  )}</span>
                </span>
                <span class="impowerx-contact-roles-docs-actions">
                  <button type="button" class="ant-btn ant-btn-ghost Button icon-button" data-roles-doc-open data-impower-id="${doc.impowerDocumentId || ''}" data-doc-name="${escapeHtml(doc.name || `Dokument ${doc.id}`)}" title="Öffnen" aria-label="Dokument öffnen">
                    ${EYE_ICON_SVG}
                  </button>
                  <button type="button" class="ant-btn ant-btn-ghost Button icon-button" data-roles-doc-unlink data-doc-id="${doc.id}" data-assignment-id="${assignmentId}" data-doc-name="${escapeHtml(doc.name || `Dokument ${doc.id}`)}" title="Entfernen" aria-label="Dokument entfernen">
                    ${TRASH_ICON_SVG}
                  </button>
                </span>
              </li>`
              )
              .join('')}</ul>`
          }
          const uploadBtn = `<button type="button" class="ant-btn ant-btn-default Button AdditionalEntityButton impowerx-contact-roles-docs-add" data-roles-docs-upload title="Dokumente hinzufügen" aria-label="Dokumente hinzufügen" style="width: 100%;">
                ${UPLOAD_ICON_SVG}
                <div class="label">Dokumente hinzufügen</div>
              </button>`
          return `${parentRow}
            <tr class="impowerx-contact-roles-docs-subrow" data-roles-docs-subrow data-assignment-id="${assignmentId}" data-assignment-index="${index}">
              <td colspan="${colSpan}">
                ${docsBody}
                ${uploadBtn}
              </td>
            </tr>`
        })
        .join('')

    const bindBuildingsMulti = (buildingsHost) => {
      const combo = buildingsHost.querySelector('[data-roles-buildings-combo]')
      const selectRoot = buildingsHost.querySelector(
        '[data-roles-buildings-select]'
      )
      const dropdown = buildingsHost.querySelector(
        '[data-roles-buildings-dropdown]'
      )
      const optionsList = buildingsHost.querySelector(
        '[data-roles-buildings-options]'
      )
      const searchInput = buildingsHost.querySelector(
        '[data-roles-buildings-search]'
      )
      const tags = buildingsHost.querySelector('[data-roles-buildings-tags]')
      const placeholder = buildingsHost.querySelector(
        '[data-roles-buildings-placeholder]'
      )
      if (!combo || !selectRoot || !tags || !placeholder) return
      if (
        selectRoot.classList.contains('ant-select-disabled') ||
        !dropdown ||
        !optionsList
      )
        return

      const sync = () => {
        const selected = new Set((state.draft.buildingIds || []).map(String))
        const buildings = state.draft.buildings || []
        tags.innerHTML = buildings
          .filter((building) => selected.has(String(building.id)))
          .map(
            (building) =>
              `<span class="impowerx-contact-roles-multi-tag" title="${escapeHtml(building.name)}">${escapeHtml(
                building.name
              )}<button type="button" class="impowerx-contact-roles-multi-tag-remove" data-roles-buildings-remove="${
                building.id
              }" aria-label="Entfernen">×</button></span>`
          )
          .join('')
        tags.style.display = selected.size ? 'flex' : 'none'
        placeholder.style.display = selected.size ? 'none' : ''
        optionsList.querySelectorAll('[data-building-id]').forEach((el) => {
          const on = selected.has(String(el.getAttribute('data-building-id')))
          el.classList.toggle('ant-select-item-option-selected', on)
          el.setAttribute('aria-selected', on ? 'true' : 'false')
        })
      }

      const toggleId = (rawId) => {
        const id = Number(rawId)
        if (!Number.isInteger(id) || id <= 0) return
        const current = (state.draft.buildingIds || [])
          .map(Number)
          .filter((item) => Number.isInteger(item) && item > 0)
        state.draft.buildingIds = current.includes(id)
          ? current.filter((item) => item !== id)
          : [...current, id]
        sync()
        const editingRow = tableHost.querySelector('[data-roles-editing]')
        if (editingRow) refreshBillingEditor(editingRow)
      }

      selectRoot.addEventListener('click', (event) => {
        if (event.target.closest('[data-roles-buildings-remove]')) return
        event.stopPropagation()
        const wasHidden = dropdown.classList.contains(
          'ant-select-dropdown-hidden'
        )
        closeComboDropdowns(dropdown)
        if (wasHidden) {
          openComboDropdown(dropdown, selectRoot)
          if (searchInput) {
            searchInput.value = ''
            optionsList.querySelectorAll('[data-building-id]').forEach((el) => {
              el.style.display = ''
            })
            searchInput.focus()
          }
        } else {
          hideComboDropdown(dropdown)
        }
      })

      tags.addEventListener('click', (event) => {
        const button = event.target.closest('[data-roles-buildings-remove]')
        if (!button) return
        event.preventDefault()
        event.stopPropagation()
        toggleId(button.getAttribute('data-roles-buildings-remove'))
      })

      optionsList.addEventListener('mousedown', (event) => {
        const option = event.target.closest('[data-building-id]')
        if (
          !option ||
          option.classList.contains('ant-select-item-option-disabled')
        )
          return
        event.preventDefault()
        event.stopPropagation()
        toggleId(option.getAttribute('data-building-id'))
      })

      searchInput?.addEventListener('click', (event) => event.stopPropagation())
      searchInput?.addEventListener('input', () => {
        const query = searchInput.value.trim().toLowerCase()
        optionsList.querySelectorAll('[data-building-id]').forEach((el) => {
          const label = (
            el.getAttribute('data-label') ||
            el.getAttribute('title') ||
            ''
          ).toLowerCase()
          el.style.display = !query || label.includes(query) ? '' : 'none'
        })
      })
      dropdown.addEventListener('click', (event) => event.stopPropagation())

      sync()
    }

    const renderBuildingsInto = async (buildingsHost) => {
      if (!buildingsHost) return
      const scopedPropertyId = isPropertyMode
        ? pagePropertyId
        : state.draft.propertyId
      if (!scopedPropertyId) {
        state.draft.buildings = []
        state.draft.buildingIds = []
        state.draft.buildingsLoaded = true
        clearPerBuildingBillingDraft()
        buildingsHost.innerHTML = buildingsMultiHtml({
          disabled: true,
          placeholder: 'Zuerst Objekt wählen',
        })
        return
      }
      state.draft.buildingsLoaded = false
      buildingsHost.innerHTML = buildingsMultiHtml({
        disabled: true,
        placeholder: 'Lade Gebäude…',
      })
      try {
        const property = await ensurePropertyCached(scopedPropertyId)
        if (
          (isPropertyMode ? pagePropertyId : state.draft.propertyId) !==
          property?.id
        )
          return
        const buildings = await loadBuildingsForProperty(property)
        if (
          (isPropertyMode ? pagePropertyId : state.draft.propertyId) !==
          property?.id
        )
          return
        state.draft.buildings = buildings
        state.draft.buildingsLoaded = true
        if (!buildings.length) {
          buildingsHost.innerHTML = buildingsMultiHtml({
            disabled: true,
            placeholder: 'Keine Gebäude',
          })
          const emptyRow =
            buildingsHost.closest('tr') ||
            tableHost.querySelector('[data-roles-editing]')
          if (emptyRow) refreshBillingEditor(emptyRow)
          return
        }
        buildingsHost.innerHTML = buildingsMultiHtml({
          buildings,
          selectedIds: state.draft.buildingIds || [],
          placeholder: 'alle Gebäude',
        })
        bindBuildingsMulti(buildingsHost)
        const editingRow =
          buildingsHost.closest('tr') ||
          tableHost.querySelector('[data-roles-editing]')
        if (editingRow) refreshBillingEditor(editingRow)
      } catch (error) {
        state.draft.buildingsLoaded = false
        buildingsHost.innerHTML = buildingsMultiHtml({
          disabled: true,
          placeholder: error.message || 'Gebäude konnten nicht geladen werden.',
        })
      }
    }

    const bindDraftRow = (tr) => {
      const buildingsHost = tr.querySelector('[data-roles-buildings]')

      bindRoleCombo(tr)
      bindKindCombo(tr)
      refreshBillingEditor(tr)
      if (isPropertyMode) bindContactCombo(tr)
      else bindPropertyCombo(tr, buildingsHost)
      renderBuildingsInto(buildingsHost)

      const portalInput = tr.querySelector('[data-roles-portal]')
      if (portalInput) {
        const syncPortalUi = () => {
          const checked = Boolean(portalInput.checked)
          state.draft.portal = checked
          const box = portalInput.closest('.ant-checkbox')
          const wrap = portalInput.closest('.ant-checkbox-wrapper')
          box?.classList.toggle('ant-checkbox-checked', checked)
          wrap?.classList.toggle('ant-checkbox-wrapper-checked', checked)
        }
        portalInput.addEventListener('change', syncPortalUi)
        portalInput.addEventListener('click', (event) =>
          event.stopPropagation()
        )
      }
    }

    const appendDraftRow = () => {
      const tbody = tableHost.querySelector('tbody')
      if (!tbody || tbody.querySelector('[data-roles-draft]')) return
      const tr = document.createElement('tr')
      tr.dataset.rolesDraft = 'true'
      tr.innerHTML = editorCellsHtml()
      tbody.appendChild(tr)
      bindDraftRow(tr)
    }

    const renderTable = async () => {
      closeComboDropdowns()
      await Promise.all([
        isPropertyMode
          ? ensurePropertyCached(pagePropertyId)
          : Promise.resolve(null),
        ...state.assignments
          .filter((row) => row.propertyId)
          .map((row) => ensurePropertyCached(row.propertyId)),
        ...state.assignments
          .filter((row) => row.contactId)
          .map((row) => ensureContactCached(row.contactId)),
      ])
      if (!state.assignments.length && !state.draftOpen) {
        tableHost.innerHTML =
          '<div class="impowerx-contact-roles-empty">Keine Rollen zugewiesen.</div>'
        return
      }
      tableHost.innerHTML = `
        <table class="impowerx-contact-roles-table${showKind ? '' : ' impowerx-contact-roles-table--no-kind'}">
          <colgroup>
            <col style="width: 2.75rem;" />
            <col />
            ${showKind ? '<col style="width: 152px;" />' : ''}
            <col />
            <col />
            <col style="width: 5.5rem;" />
            <col style="width: 15rem;" />
          </colgroup>
          <thead>
            <tr>
              <th class="impowerx-contact-roles-toggle-cell"></th>
              <th>Bezeichnung</th>
              ${showKind ? '<th>Art</th>' : ''}
              <th>${isPropertyMode ? 'Kontakt' : 'Objekt'}</th>
              <th>Gebäude</th>
              <th>Portal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            ${assignmentRowsHtml()}
          </tbody>
        </table>
      `
      if (state.draftOpen) appendDraftRow()
      const editingRow = tableHost.querySelector('[data-roles-editing]')
      if (editingRow) bindDraftRow(editingRow)
    }

    const persist = async () => {
      if (state.saving) return
      state.saving = true
      try {
        const url = isPropertyMode
          ? `/api/impowerX/properties/${pagePropertyId}/roles`
          : `/api/impowerX/contacts/${pageContactId}/roles`
        const assignments = isPropertyMode
          ? state.assignments.map((row) => ({
              ...(row.id ? { id: row.id } : {}),
              contactId: row.contactId,
              roleId: row.roleId,
              kindId: row.kindId || null,
              buildingInvoices: row.buildingInvoices ?? null,
              buildingIds: row.buildingIds,
              portal: Boolean(row.portal),
            }))
          : state.assignments.map((row) => ({
              ...(row.id ? { id: row.id } : {}),
              roleId: row.roleId,
              kindId: row.kindId || null,
              buildingInvoices: row.buildingInvoices ?? null,
              propertyId: row.propertyId,
              buildingIds: row.buildingIds,
              portal: Boolean(row.portal),
            }))
        const data = await luxRequestJson(url, {
          method: 'PUT',
          body: JSON.stringify({
            assignments,
            ...(roleTypeFilter ? { roleType: roleTypeFilter } : {}),
          }),
        })
        state.assignments = (data.assignments || []).filter(matchesRoleType)
        const validIds = new Set(
          state.assignments
            .map((row) => Number(row.id))
            .filter((id) => Number.isInteger(id) && id > 0)
        )
        for (const id of [...state.expandedAssignmentIds]) {
          if (!validIds.has(id)) state.expandedAssignmentIds.delete(id)
        }
        for (const id of [...state.expandedBillingIds]) {
          if (!validIds.has(id)) state.expandedBillingIds.delete(id)
        }
        for (const id of [...state.docsByAssignmentId.keys()]) {
          if (!validIds.has(id)) state.docsByAssignmentId.delete(id)
        }
        await renderTable()
      } catch (error) {
        notify(error.message || 'Rollen konnten nicht gespeichert werden.')
        await reload()
      } finally {
        state.saving = false
      }
    }

    const reload = async () => {
      const assignmentsUrl = isPropertyMode
        ? propertyAssignmentsUrl()
        : `/api/impowerX/contacts/${pageContactId}/roles`
      const [catalog, assigned] = await Promise.all([
        luxRequestJson('/api/impowerX/contact-roles'),
        luxRequestJson(assignmentsUrl),
      ])
      state.catalogRoles = (catalog.roles || []).filter(
        (role) => !roleTypeFilter || role.type === roleTypeFilter
      )
      state.catalogKinds = catalog.kinds || []
      state.assignments = (assigned.assignments || []).filter(matchesRoleType)
      state.expandedAssignmentIds.clear()
      state.expandedBillingIds.clear()
      state.docsByAssignmentId.clear()
      state.docsLoadingIds.clear()
      resetDraft()
      await renderTable()
    }

    const startEdit = async (index) => {
      const row = state.assignments[index]
      if (!row) return
      state.draftOpen = false
      state.editingIndex = index
      const property = row.propertyId ? propertyCache.get(row.propertyId) : null
      const contact = row.contactId ? contactCache.get(row.contactId) : null
      const buildingIds = Array.isArray(row.buildingIds)
        ? row.buildingIds
            .map(Number)
            .filter((id) => Number.isInteger(id) && id > 0)
        : []
      state.editBaseline = {
        id: row.id ? Number(row.id) : null,
        contactId: row.contactId != null ? Number(row.contactId) : null,
        propertyId: row.propertyId != null ? Number(row.propertyId) : null,
        buildingIds: buildingIds.length ? [...buildingIds] : null,
        documentCount: Number(row.documentCount) || 0,
        roleName: row.roleName || '',
      }
      state.draft = {
        contactId: row.contactId || '',
        contactLabel: contact?.name || row.contactName || '',
        roleId: row.roleId,
        kindId: row.kindId || '',
        ...draftBillingFromAssignment(row),
        propertyId: isPropertyMode ? pagePropertyId : row.propertyId,
        propertyLabel:
          property?.name || (row.propertyId ? `Objekt ${row.propertyId}` : ''),
        buildingIds: [...buildingIds],
        buildings: [],
        portal: Boolean(row.portal),
      }
      await renderTable()
    }

    const confirmUpdateAssignmentDocuments = (assignment, docCount) =>
      new Promise((resolve) => {
        // Defer so the triggering click cannot dismiss the dialog immediately.
        setTimeout(() => {
          const existing = document.querySelector(
            '[data-roles-docs-update-dialog]'
          )
          if (existing) existing.remove()

          const roleLabel = assignment?.roleName || 'Rolle'
          const count = Number(docCount) || 0
          const countLabel =
            count === 1
              ? '1 verknüpftes Dokument'
              : `${count} verknüpfte Dokumente`

          const backdrop = document.createElement('div')
          backdrop.className = 'impowerx-contact-roles-docs-dialog-backdrop'
          backdrop.setAttribute('data-roles-docs-update-dialog', '1')
          backdrop.innerHTML = `
          <div class="impowerx-contact-roles-docs-dialog" role="dialog" aria-modal="true" aria-labelledby="roles-docs-update-title">
            <h3 id="roles-docs-update-title">Dokumente aktualisieren?</h3>
            <p>
              Die Zuweisung „${escapeHtml(roleLabel)}“ wurde geändert.
              Sollen Objekt, Gebäude und Kontakt auch für ${escapeHtml(countLabel)} übernommen werden?
            </p>
            <div class="impowerx-contact-roles-docs-dialog-actions">
              <button type="button" class="ant-btn ant-btn-default Button" data-roles-docs-update-cancel>Abbrechen</button>
              <button type="button" class="ant-btn ant-btn-primary Button" data-roles-docs-update-yes>Dokumente aktualisieren</button>
              <button type="button" class="ant-btn ant-btn-default Button" data-roles-docs-update-no>Nur Rolle speichern</button>
            </div>
          </div>`

          const finish = (result) => {
            backdrop.remove()
            resolve(result)
          }
          backdrop.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (
              event.target === backdrop ||
              event.target.closest('[data-roles-docs-update-cancel]')
            ) {
              finish(null)
              return
            }
            if (event.target.closest('[data-roles-docs-update-yes]')) {
              finish(true)
              return
            }
            if (event.target.closest('[data-roles-docs-update-no]')) {
              finish(false)
            }
          })
          document.body.appendChild(backdrop)
          backdrop.querySelector('[data-roles-docs-update-cancel]')?.focus()
        }, 0)
      })

    const syncImpowerDocumentsForAssignment = async (assignment, docsHint) => {
      if (!assignment?.id) return
      const token = JSON.parse(localStorage.getItem('auth') || '{}').token
      if (!token) {
        notify('Keine Anmeldung.')
        return
      }
      const contactId = Number(assignment.contactId || pageContactId)
      if (!Number.isInteger(contactId) || contactId <= 0) {
        notify('Kontakt fehlt — Dokumente wurden nicht aktualisiert.')
        return
      }
      const buildingId = buildingIdForImpowerUpload(assignment)
      let docs = Array.isArray(docsHint) ? docsHint : null
      if (!docs) {
        docs = state.docsByAssignmentId.get(Number(assignment.id))
      }
      if (!Array.isArray(docs)) {
        docs = await loadAssignmentDocuments(assignment, { force: true })
      }
      const withImpower = (docs || []).filter(
        (doc) =>
          Number.isInteger(Number(doc.impowerDocumentId)) &&
          Number(doc.impowerDocumentId) > 0
      )
      if (!withImpower.length) {
        notify('Keine Impower-Dokumente zum Aktualisieren.')
        return
      }

      let updated = 0
      let failed = 0
      for (const doc of withImpower) {
        const payload = {
          id: Number(doc.impowerDocumentId),
          name: doc.name || `Dokument ${doc.impowerDocumentId}`,
          contactId,
          ...(assignment.propertyId != null
            ? { propertyId: assignment.propertyId }
            : {}),
          ...(buildingId != null ? { buildingId } : {}),
        }
        try {
          const response = await fetch(
            '/services/pmp-document/api/v1/documents',
            {
              method: 'PUT',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify([payload]),
            }
          )
          if (response.ok) updated += 1
          else failed += 1
        } catch (_) {
          failed += 1
        }
      }
      if (updated && !failed) {
        notify(
          updated === 1
            ? 'Dokument aktualisiert.'
            : `${updated} Dokumente aktualisiert.`,
          'success'
        )
      } else if (updated && failed) {
        notify(`${updated} aktualisiert, ${failed} fehlgeschlagen.`)
      } else {
        notify('Dokumente konnten nicht aktualisiert werden.')
      }
    }

    const saveDraft = async () => {
      const amountInput = tableHost.querySelector(
        '[data-roles-monthly-invoice-net]'
      )
      if (amountInput && !amountInput.checkValidity()) {
        notify(
          'Bitte einen gültigen Netto-Rechnungsbetrag mit höchstens zwei Nachkommastellen eingeben.'
        )
        return
      }
      const roleId = Number(state.draft.roleId)
      if (!Number.isInteger(roleId) || roleId <= 0) {
        notify('Bitte eine Rolle wählen.')
        return
      }
      const draftContactId = Number(state.draft.contactId)
      if (
        isPropertyMode &&
        (!Number.isInteger(draftContactId) || draftContactId <= 0)
      ) {
        notify('Bitte einen Kontakt wählen.')
        return
      }
      const role = state.catalogRoles.find((item) => item.id === roleId)
      const propertyId = isPropertyMode
        ? pagePropertyId
        : state.draft.propertyId
      const buildingIds =
        propertyId && (state.draft.buildingIds || []).length
          ? state.draft.buildingIds
          : null
      const key = isPropertyMode
        ? `${draftContactId}:${roleId}`
        : `${roleId}:${propertyId ?? 'global'}`
      const exists = state.assignments.some((row, index) => {
        if (index === state.editingIndex) return false
        const rowKey = isPropertyMode
          ? `${row.contactId}:${row.roleId}`
          : `${row.roleId}:${row.propertyId ?? 'global'}`
        return rowKey === key
      })
      if (exists) {
        notify(
          isPropertyMode
            ? 'Diese Rolle ist für diesen Kontakt bereits zugewiesen.'
            : 'Diese Rolle ist für diesen Objektbezug bereits zugewiesen.'
        )
        return
      }
      const kindId = Number(state.draft.kindId)
      const kind =
        showKind &&
        Boolean(role?.kindSelectable) &&
        Number.isInteger(kindId) &&
        kindId > 0
          ? state.catalogKinds.find((item) => item.id === kindId)
          : null
      const editingIndex = state.editingIndex
      const previous =
        Number.isInteger(editingIndex) && state.assignments[editingIndex]
          ? state.assignments[editingIndex]
          : null
      // When the kind column is hidden (internal PropertyCare), keep any existing kind
      // only if the selected role still allows kinds — otherwise clear it.
      const preservedKindId =
        !showKind &&
        previous?.kindId != null &&
        Boolean(role?.kindSelectable) &&
        Number.isInteger(Number(previous.kindId)) &&
        Number(previous.kindId) > 0
          ? Number(previous.kindId)
          : null
      const commercial =
        (kind?.name || (preservedKindId ? previous?.kindName : null)) ===
        'Gewerblich'
      let buildingInvoices = null
      if (commercial) {
        syncBillingModeToScope()
        const selectedScope = (state.draft.buildingIds || [])
          .map(Number)
          .filter((id) => Number.isInteger(id) && id > 0)
        // Per-building invoices require a property; never reuse leftover draft keys.
        const usePerBuilding =
          Boolean(propertyId) && state.draft.billingMode === 'perBuilding'
        if (usePerBuilding) {
          const scopedBuildings = buildingsForBillingScope()
          const targetIds = selectedScope.length
            ? selectedScope
            : scopedBuildings.map((building) => Number(building.id))
          if (!targetIds.length) {
            const sameProperty =
              previous?.propertyId != null &&
              Number(previous.propertyId) === Number(propertyId)
            const previousPerBuilding = perBuildingInvoices(
              previous?.buildingInvoices
            )
            // Still loading buildings for this property: keep the existing split.
            buildingInvoices =
              !state.draft.buildingsLoaded &&
              sameProperty &&
              previousPerBuilding.length
                ? previous.buildingInvoices
                : null
          } else {
            const entries = []
            for (const buildingId of targetIds) {
              const parsed = parseDraftInvoiceEntry(
                buildingId,
                state.draft.buildingInvoiceDrafts?.[buildingId] || {}
              )
              if (parsed.error) {
                notify(
                  'Bitte einen gültigen Netto-Rechnungsbetrag mit höchstens zwei Nachkommastellen eingeben.'
                )
                return
              }
              entries.push(parsed)
            }
            buildingInvoices = selectedScope.length
              ? entries
              : entries.filter(
                  (entry) =>
                    entry.monthlyInvoiceNet != null || entry.invoiceVat != null
                )
            if (!buildingInvoices.length) buildingInvoices = null
          }
        } else {
          const monthlyInvoiceNet = parseBillingAmount(
            state.draft.monthlyInvoiceNet
          )
          if (monthlyInvoiceNet != null && !Number.isFinite(monthlyInvoiceNet)) {
            notify(
              'Bitte einen gültigen Netto-Rechnungsbetrag mit höchstens zwei Nachkommastellen eingeben.'
            )
            return
          }
          if (
            monthlyInvoiceNet != null ||
            state.draft.invoiceVat != null
          ) {
            buildingInvoices = [
              {
                buildingId: null,
                monthlyInvoiceNet,
                invoiceVat: state.draft.invoiceVat ?? null,
              },
            ]
          }
        }
      }
      const next = {
        buildingInvoices,
        contactId: isPropertyMode ? draftContactId : pageContactId,
        contactName: isPropertyMode
          ? state.draft.contactLabel ||
            contactCache.get(draftContactId)?.name ||
            `Kontakt ${draftContactId}`
          : '',
        roleId,
        roleName: role?.name || `Rolle ${roleId}`,
        roleType: role?.type || '',
        kindId: kind ? kindId : preservedKindId,
        kindName: kind
          ? kind.name || null
          : preservedKindId
            ? previous?.kindName || null
            : null,
        propertyId,
        buildingIds: buildingIds
          ? buildingIds
              .map(Number)
              .filter((id) => Number.isInteger(id) && id > 0)
          : null,
        portal: Boolean(state.draft.portal),
      }

      const baseline = state.editBaseline
      const isEdit = Boolean(previous?.id || baseline?.id)
      const assignmentIdToSync = Number(previous?.id || baseline?.id) || null

      const normalizeScopeId = (value) => {
        const id = Number(value)
        return Number.isInteger(id) && id > 0 ? id : null
      }
      const sameBuildingIds = (left, right) => {
        const a = Array.isArray(left)
          ? [...left]
              .map(Number)
              .filter((id) => Number.isInteger(id) && id > 0)
              .sort((x, y) => x - y)
          : []
        const b = Array.isArray(right)
          ? [...right]
              .map(Number)
              .filter((id) => Number.isInteger(id) && id > 0)
              .sort((x, y) => x - y)
          : []
        return a.length === b.length && a.every((id, i) => id === b[i])
      }
      const baselineContactId = normalizeScopeId(
        baseline?.contactId ?? previous?.contactId
      )
      const baselinePropertyId = normalizeScopeId(
        isPropertyMode
          ? pagePropertyId
          : (baseline?.propertyId ?? previous?.propertyId)
      )
      const nextContactId = normalizeScopeId(next.contactId)
      const nextPropertyId = normalizeScopeId(next.propertyId)
      const scopeChanged =
        isEdit &&
        (baselineContactId !== nextContactId ||
          baselinePropertyId !== nextPropertyId ||
          !sameBuildingIds(
            baseline?.buildingIds ?? previous?.buildingIds,
            next.buildingIds
          ))

      let updateDocuments = false
      let docsToSync = null
      // Only ask about Impower doc metadata when contact/property/buildings actually changed.
      if (isEdit && assignmentIdToSync && scopeChanged) {
        const assignmentForDocs = previous?.id
          ? previous
          : {
              id: assignmentIdToSync,
              documentCount: baseline?.documentCount || 0,
            }
        const cachedDocs = state.docsByAssignmentId.get(assignmentIdToSync)
        let docCount = Math.max(
          Number(baseline?.documentCount) || 0,
          Number(previous?.documentCount) || 0,
          Array.isArray(cachedDocs) ? cachedDocs.length : 0
        )
        if (docCount < 1) {
          try {
            docsToSync = await loadAssignmentDocuments(assignmentForDocs, {
              force: true,
            })
            docCount = Array.isArray(docsToSync) ? docsToSync.length : 0
          } catch (_) {
            docsToSync = null
          }
        } else if (Array.isArray(cachedDocs)) {
          docsToSync = cachedDocs
        }
        if (docCount > 0) {
          const choice = await confirmUpdateAssignmentDocuments(
            {
              ...(previous || {}),
              ...next,
              roleName:
                next.roleName || baseline?.roleName || previous?.roleName,
            },
            docCount
          )
          if (choice === null) return
          updateDocuments = choice === true
          if (updateDocuments && !Array.isArray(docsToSync)) {
            try {
              docsToSync = await loadAssignmentDocuments(assignmentForDocs, {
                force: true,
              })
            } catch (_) {
              docsToSync = null
            }
          }
        }
      }

      if (Number.isInteger(editingIndex) && state.assignments[editingIndex]) {
        state.assignments[editingIndex] = {
          ...state.assignments[editingIndex],
          ...next,
        }
      } else {
        state.assignments.push(next)
      }
      resetDraft()
      await persist()
      if (updateDocuments && assignmentIdToSync) {
        const synced = state.assignments.find(
          (row) => Number(row.id) === assignmentIdToSync
        )
        if (synced) await syncImpowerDocumentsForAssignment(synced, docsToSync)
        else
          notify(
            'Zuweisung nach dem Speichern nicht gefunden — Dokumente nicht aktualisiert.'
          )
      }
    }

    document.addEventListener('click', (event) => {
      if (!document.body.contains(host)) return
      if (
        event.target.closest(
          '[data-roles-role-combo], [data-roles-kind-combo], [data-roles-property-combo], [data-roles-contact-combo], [data-roles-buildings-combo]'
        )
      )
        return
      closeComboDropdowns()
    })

    const buildingIdForImpowerUpload = (assignment) => {
      const ids = Array.isArray(assignment.buildingIds)
        ? assignment.buildingIds
            .map(Number)
            .filter((id) => Number.isInteger(id) && id > 0)
        : []
      return ids.length === 1 ? ids[0] : null
    }

    const openAssignmentDocument = async (impowerDocumentId, docName = '') => {
      if (!impowerDocumentId) {
        notify('Dokument hat keine Impower-ID.')
        return
      }
      const token = JSON.parse(localStorage.getItem('auth') || '{}').token
      if (!token) {
        notify('Keine Anmeldung.')
        return
      }

      const displayName =
        String(docName || '').trim() || `Dokument ${impowerDocumentId}`

      // Open synchronously on user gesture so the browser creates a real popup
      // window (not a tab). Fetching first would lose the gesture context.
      const width = Math.min(
        960,
        Math.max(640, Math.round(window.screen.availWidth * 0.55))
      )
      const height = Math.min(
        800,
        Math.max(480, Math.round(window.screen.availHeight * 0.7))
      )
      const left = Math.max(
        0,
        Math.round((window.screen.availWidth - width) / 2)
      )
      const top = Math.max(
        0,
        Math.round((window.screen.availHeight - height) / 2)
      )
      const previewName = `lux-role-doc-preview-${impowerDocumentId}`
      const preview = window.open(
        'about:blank',
        previewName,
        `popup=yes,width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes`
      )
      if (!preview) {
        notify('Popup wurde blockiert. Bitte Pop-ups erlauben.')
        return
      }
      try {
        preview.opener = null
      } catch (_) {
        /* ignore */
      }
      try {
        preview.document.title = displayName
        preview.document.body.innerHTML =
          '<p style="font-family:sans-serif;padding:16px;color:#666;">Dokument wird geladen…</p>'
      } catch (_) {
        /* ignore cross-origin/about:blank quirks */
      }

      try {
        const response = await fetch(
          `${baseApiUrl}/api/impowerX/documents/${encodeURIComponent(impowerDocumentId)}/download`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (!response.ok) throw new Error('Download fehlgeschlagen.')
        const blob = await response.blob()
        const type = blob.type || 'application/octet-stream'
        const file = new File([blob], displayName, { type })
        const objectUrl = URL.createObjectURL(file)
        const safeTitle = escapeHtml(displayName)
        const safeType = escapeHtml(type)
        // HTML shell keeps the real document name as window title (blob: URLs do not).
        preview.document.open()
        preview.document.write(`<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>${safeTitle}</title>
<style>html,body{margin:0;height:100%;background:#fff} iframe,embed,img{border:0;width:100%;height:100%;display:block;object-fit:contain}</style>
</head><body>`)
        if (type.startsWith('image/')) {
          preview.document.write(
            `<img src="${objectUrl}" alt="${safeTitle}" />`
          )
        } else if (type === 'application/pdf' || type.includes('pdf')) {
          preview.document.write(
            `<iframe src="${objectUrl}" title="${safeTitle}"></iframe>`
          )
        } else {
          preview.document.write(
            `<p style="font-family:sans-serif;padding:16px;">
              <a href="${objectUrl}" download="${safeTitle}">${safeTitle}</a> herunterladen
            </p>`
          )
        }
        preview.document.write('</body></html>')
        preview.document.close()
        preview.document.title = displayName
        setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000)
      } catch (error) {
        try {
          preview.close()
        } catch (_) {
          /* ignore */
        }
        notify(error.message || 'Dokument konnte nicht geöffnet werden.')
      }
    }

    const confirmRemoveAssignmentDocument = (docName) =>
      new Promise((resolve) => {
        const existing = document.querySelector(
          '[data-roles-docs-remove-dialog]'
        )
        if (existing) existing.remove()

        const backdrop = document.createElement('div')
        backdrop.className = 'impowerx-contact-roles-docs-dialog-backdrop'
        backdrop.setAttribute('data-roles-docs-remove-dialog', '1')
        backdrop.innerHTML = `
          <div class="impowerx-contact-roles-docs-dialog" role="dialog" aria-modal="true" aria-labelledby="roles-docs-remove-title">
            <h3 id="roles-docs-remove-title">Dokument entfernen?</h3>
            <p>
              Soll „${escapeHtml(docName || 'Dokument')}“ von dieser Rollenzuweisung getrennt
              oder das Dokument in Lux vollständig gelöscht werden?
            </p>
            <div class="impowerx-contact-roles-docs-dialog-actions">
              <button type="button" class="ant-btn ant-btn-default Button" data-roles-docs-remove-cancel>Abbrechen</button>
              <button type="button" class="ant-btn ant-btn-primary Button" data-roles-docs-remove-delete style="background:#cf1322;border-color:#cf1322;">Dokument löschen</button>
              <button type="button" class="ant-btn ant-btn-default Button" data-roles-docs-remove-unlink>Verknüpfung löschen</button>
            </div>
          </div>`

        const finish = (result) => {
          backdrop.remove()
          resolve(result)
        }
        backdrop.addEventListener('click', (event) => {
          if (
            event.target === backdrop ||
            event.target.closest('[data-roles-docs-remove-cancel]')
          ) {
            finish(null)
            return
          }
          if (event.target.closest('[data-roles-docs-remove-unlink]')) {
            finish({ deleteDocument: false })
            return
          }
          if (event.target.closest('[data-roles-docs-remove-delete]')) {
            finish({ deleteDocument: true })
          }
        })
        document.body.appendChild(backdrop)
        backdrop.querySelector('[data-roles-docs-remove-cancel]')?.focus()
      })

    const confirmRemoveRoleAssignment = (assignment) =>
      new Promise((resolve) => {
        const existing = document.querySelector(
          '[data-roles-assignment-remove-dialog]'
        )
        if (existing) existing.remove()

        const roleLabel = assignment?.roleName || 'Rolle'
        const docCount = Number(assignment?.documentCount) || 0
        const docHint =
          docCount > 0
            ? ` Verknüpfte Dokumente (${docCount}) werden von der Zuweisung getrennt.`
            : ''

        const backdrop = document.createElement('div')
        backdrop.className = 'impowerx-contact-roles-docs-dialog-backdrop'
        backdrop.setAttribute('data-roles-assignment-remove-dialog', '1')
        backdrop.innerHTML = `
          <div class="impowerx-contact-roles-docs-dialog" role="dialog" aria-modal="true" aria-labelledby="roles-assignment-remove-title">
            <h3 id="roles-assignment-remove-title">Rolle entfernen?</h3>
            <p>
              Soll die Zuweisung „${escapeHtml(roleLabel)}“ wirklich entfernt werden?${escapeHtml(docHint)}
            </p>
            <div class="impowerx-contact-roles-docs-dialog-actions">
              <button type="button" class="ant-btn ant-btn-default Button" data-roles-assignment-remove-cancel>Abbrechen</button>
              <button type="button" class="ant-btn ant-btn-primary Button" data-roles-assignment-remove-confirm style="background:#cf1322;border-color:#cf1322;">Rolle löschen</button>
            </div>
          </div>`

        const finish = (confirmed) => {
          backdrop.remove()
          resolve(confirmed)
        }
        backdrop.addEventListener('click', (event) => {
          if (
            event.target === backdrop ||
            event.target.closest('[data-roles-assignment-remove-cancel]')
          ) {
            finish(false)
            return
          }
          if (event.target.closest('[data-roles-assignment-remove-confirm]')) {
            finish(true)
          }
        })
        document.body.appendChild(backdrop)
        backdrop.querySelector('[data-roles-assignment-remove-cancel]')?.focus()
      })

    const invalidateAssignmentDocs = (assignmentId) => {
      if (assignmentId == null) return
      state.docsByAssignmentId.delete(assignmentId)
    }

    const loadAssignmentDocuments = async (
      assignment,
      { force = false } = {}
    ) => {
      if (!assignment?.id) return []
      const assignmentId = Number(assignment.id)
      if (!force && state.docsByAssignmentId.has(assignmentId)) {
        return state.docsByAssignmentId.get(assignmentId) || []
      }
      state.docsLoadingIds.add(assignmentId)
      try {
        const data = await luxRequestJson(
          `/api/impowerX/contact-role-assignments/${assignmentId}/documents`
        )
        const docs = Array.isArray(data?.documents) ? data.documents : []
        state.docsByAssignmentId.set(assignmentId, docs)
        assignment.documentCount = docs.length
        return docs
      } catch (error) {
        state.expandedAssignmentIds.delete(assignmentId)
        notify(error.message || 'Dokumente konnten nicht geladen werden.')
        return []
      } finally {
        state.docsLoadingIds.delete(assignmentId)
      }
    }

    const toggleAssignmentDocuments = async (assignment) => {
      if (!assignment?.id) {
        notify('Bitte die Rolle zuerst speichern.')
        return
      }
      const assignmentId = Number(assignment.id)
      if (state.expandedAssignmentIds.has(assignmentId)) {
        state.expandedAssignmentIds.delete(assignmentId)
        await renderTable()
        return
      }
      state.expandedAssignmentIds.add(assignmentId)
      await renderTable()
      await loadAssignmentDocuments(assignment)
      await renderTable()
    }

    const unlinkAssignmentDocument = async (
      assignment,
      documentId,
      { docName = '' } = {}
    ) => {
      if (!assignment?.id) return
      const assignmentId = Number(assignment.id)
      const choice = await confirmRemoveAssignmentDocument(docName)
      if (!choice) return
      const shouldDelete = Boolean(choice.deleteDocument)
      try {
        const qs = shouldDelete ? '?deleteDocument=true' : ''
        await luxRequestJson(
          `/api/impowerX/contact-role-assignments/${assignmentId}/documents/${documentId}${qs}`,
          { method: 'DELETE' }
        )
        notify(
          shouldDelete ? 'Dokument gelöscht.' : 'Verknüpfung entfernt.',
          'success'
        )
        const cached = state.docsByAssignmentId.get(assignmentId)
        if (Array.isArray(cached)) {
          const next = cached.filter((doc) => Number(doc.id) !== documentId)
          state.docsByAssignmentId.set(assignmentId, next)
          assignment.documentCount = next.length
        } else {
          assignment.documentCount = Math.max(
            0,
            (Number(assignment.documentCount) || 0) - 1
          )
          invalidateAssignmentDocs(assignmentId)
        }
        await renderTable()
      } catch (error) {
        notify(error.message || 'Entfernen fehlgeschlagen.')
      }
    }

    const uploadDocumentsForAssignment = async (assignment, files) => {
      if (!assignment?.id) {
        notify('Bitte die Rolle zuerst speichern.')
        return
      }
      const token = JSON.parse(localStorage.getItem('auth') || '{}').token
      if (!token) {
        notify('Keine Anmeldung.')
        return
      }
      const filesArray = Array.from(files || [])
      if (!filesArray.length) return

      const buildingId = buildingIdForImpowerUpload(assignment)
      const contactId = Number(assignment.contactId || pageContactId)
      if (!Number.isInteger(contactId) || contactId <= 0) {
        notify('Kontakt der Zuweisung fehlt — Upload abgebrochen.')
        return
      }
      let uploaded = 0
      for (const file of filesArray) {
        const uploadParams = {
          name: file.name.replace(/[\\/&?:]/g, '_'),
          contactId,
          sourceType: 'OTHER',
          ocrState: 'NO_OCR',
          ...(assignment.propertyId != null
            ? { propertyId: assignment.propertyId }
            : {}),
        }
        const uploadResult = await uploadImpowerDocument({
          file,
          token,
          uploadParams,
          apiBaseUrl: '',
        })
        if (!uploadResult.success || !uploadResult.data?.id) {
          notify(uploadResult.error || `Upload fehlgeschlagen: ${file.name}`)
          continue
        }
        let impowerDoc = uploadResult.data
        const updatePayload = {
          id: impowerDoc.id,
          name: impowerDoc.name,
          contactId,
          ...(assignment.propertyId != null
            ? { propertyId: assignment.propertyId }
            : {}),
          ...(buildingId != null ? { buildingId } : {}),
        }
        const updateResponse = await fetch(
          '/services/pmp-document/api/v1/documents',
          {
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify([updatePayload]),
          }
        )
        if (updateResponse.ok) {
          const updated = await updateResponse.json().catch(() => null)
          if (Array.isArray(updated) && updated[0]) impowerDoc = updated[0]
        }
        try {
          await luxRequestJson(
            `/api/impowerX/contact-role-assignments/${assignment.id}/documents`,
            {
              method: 'POST',
              body: JSON.stringify({
                impowerDocumentId: impowerDoc.id,
                name: impowerDoc.name || file.name,
                fileLink: impowerDoc.fileLink || impowerDoc.url || null,
              }),
            }
          )
          uploaded += 1
        } catch (error) {
          notify(error.message || 'Lux-Registrierung fehlgeschlagen.')
        }
      }
      if (uploaded) {
        const assignmentId = Number(assignment.id)
        assignment.documentCount =
          (Number(assignment.documentCount) || 0) + uploaded
        invalidateAssignmentDocs(assignmentId)
        state.expandedAssignmentIds.add(assignmentId)
        notify(
          uploaded === 1
            ? 'Dokument hochgeladen.'
            : `${uploaded} Dokumente hochgeladen.`,
          'success'
        )
        await loadAssignmentDocuments(assignment, { force: true })
        await renderTable()
      }
    }

    tableHost.addEventListener('click', async (event) => {
      const billingToggle = event.target.closest('[data-roles-billing-toggle]')
      if (billingToggle) {
        event.preventDefault()
        event.stopPropagation()
        const roleRow = billingToggle.closest('tr')
        const billingRow = roleRow?.nextElementSibling
        if (!billingRow?.hasAttribute('data-roles-billing-row')) return
        if (billingRow.hasAttribute('data-roles-billing-draft')) {
          state.billingDraftOpen = !state.billingDraftOpen
          setBillingRowOpen(billingRow, state.billingDraftOpen)
          return
        }
        const assignmentId = Number(
          billingRow.getAttribute('data-assignment-id')
        )
        if (!Number.isInteger(assignmentId) || assignmentId <= 0) return
        const open = !state.expandedBillingIds.has(assignmentId)
        if (open) state.expandedBillingIds.add(assignmentId)
        else state.expandedBillingIds.delete(assignmentId)
        setBillingRowOpen(billingRow, open)
        return
      }
      if (event.target.closest('[data-roles-save]')) {
        event.preventDefault()
        event.stopPropagation()
        await saveDraft()
        return
      }
      if (event.target.closest('[data-roles-cancel]')) {
        event.preventDefault()
        resetDraft()
        await renderTable()
        return
      }
      const editBtn = event.target.closest('[data-roles-edit]')
      if (editBtn) {
        event.preventDefault()
        const row = event.target.closest('[data-assignment-index]')
        const index = Number(row?.getAttribute('data-assignment-index'))
        if (!Number.isInteger(index) || !state.assignments[index]) return
        await startEdit(index)
        return
      }
      const uploadBtn = event.target.closest('[data-roles-docs-upload]')
      if (uploadBtn) {
        event.preventDefault()
        const row = event.target.closest('[data-assignment-index]')
        const index = Number(row?.getAttribute('data-assignment-index'))
        const assignment = state.assignments[index]
        if (!assignment) return
        if (!assignment.id) {
          notify('Bitte die Rolle zuerst speichern.')
          return
        }
        const input = document.createElement('input')
        input.type = 'file'
        input.multiple = true
        input.accept = '.pdf,.doc,.docx,.xlsx,.jpg,.jpeg,.png'
        input.style.display = 'none'
        input.addEventListener('change', async () => {
          try {
            await uploadDocumentsForAssignment(assignment, input.files)
          } finally {
            input.remove()
          }
        })
        document.body.appendChild(input)
        input.click()
        return
      }
      const listBtn = event.target.closest('[data-roles-docs-list]')
      if (listBtn) {
        event.preventDefault()
        const row = event.target.closest('[data-assignment-index]')
        const index = Number(row?.getAttribute('data-assignment-index'))
        const assignment = state.assignments[index]
        if (!assignment?.id) {
          notify('Bitte die Rolle zuerst speichern.')
          return
        }
        await toggleAssignmentDocuments(assignment)
        return
      }
      const openDocBtn = event.target.closest('[data-roles-doc-open]')
      if (openDocBtn) {
        event.preventDefault()
        await openAssignmentDocument(
          Number(openDocBtn.getAttribute('data-impower-id')),
          openDocBtn.getAttribute('data-doc-name') || ''
        )
        return
      }
      const unlinkDocBtn = event.target.closest('[data-roles-doc-unlink]')
      if (unlinkDocBtn) {
        event.preventDefault()
        const documentId = Number(unlinkDocBtn.getAttribute('data-doc-id'))
        const assignmentId = Number(
          unlinkDocBtn.getAttribute('data-assignment-id')
        )
        const docName = unlinkDocBtn.getAttribute('data-doc-name') || ''
        const assignment =
          state.assignments.find((row) => Number(row.id) === assignmentId) ||
          state.assignments[
            Number(
              unlinkDocBtn
                .closest('[data-assignment-index]')
                ?.getAttribute('data-assignment-index')
            )
          ]
        if (!assignment || !Number.isInteger(documentId) || documentId <= 0)
          return
        await unlinkAssignmentDocument(assignment, documentId, { docName })
        return
      }
      const removeBtn = event.target.closest('[data-roles-remove]')
      if (!removeBtn) return
      event.preventDefault()
      const row = event.target.closest('[data-assignment-index]')
      const index = Number(row?.getAttribute('data-assignment-index'))
      if (!Number.isInteger(index)) return
      const removed = state.assignments[index]
      if (!removed) return
      const confirmed = await confirmRemoveRoleAssignment(removed)
      if (!confirmed) return
      if (removed.id) {
        const removedId = Number(removed.id)
        state.expandedAssignmentIds.delete(removedId)
        state.expandedBillingIds.delete(removedId)
        invalidateAssignmentDocs(removedId)
      }
      state.assignments = state.assignments.filter((_, i) => i !== index)
      resetDraft()
      await persist()
    })

    host
      .querySelector('[data-roles-add]')
      ?.addEventListener('click', async (event) => {
        event.preventDefault()
        if (state.draftOpen || state.editingIndex != null) {
          tableHost
            .querySelector(
              '[data-roles-draft] .ant-select-selection-search-input, [data-roles-editing] .ant-select-selection-search-input'
            )
            ?.focus()
          return
        }
        state.draftOpen = true
        state.billingDraftOpen = false
        await renderTable()
      })

    try {
      await reload()
    } catch (error) {
      tableHost.innerHTML = `<div class="impowerx-contact-roles-empty">${escapeHtml(
        error.message || 'Rollen konnten nicht geladen werden.'
      )}</div>`
    }
  }

  function initContactRolesField() {
    const contactId = getEditContactId()
    if (!contactId) return false

    const isPerson = /\/edit-person\//.test(window.location.pathname)
    const root = isPerson
      ? document.querySelector('.ContactEditing #person')
      : document.querySelector('#info')
    if (!root) return false

    const existingRow = root.querySelector(
      '[data-impowerx-contact-roles="true"]'
    )
    if (existingRow) {
      if (
        existingRow._contactId === contactId &&
        document.body.contains(existingRow)
      ) {
        return true
      }
      existingRow.remove()
    }

    const subSectionContent = root.querySelector('.sub-section-content')
    const rows = subSectionContent?.querySelectorAll('.sub-section-content-row')
    const lastRow = rows?.[rows.length - 1]
    if (!lastRow) return false

    const wrap = document.createElement('div')
    wrap._contactId = contactId
    wrap.dataset.impowerxContactExtra = 'true'
    wrap.dataset.impowerxContactRoles = 'true'
    wrap.style.display = 'contents'

    // Keep order: Steuernummer+Ehepartner → Datenschutzerklärung → Kontaktrollen
    const privacyRow = root
      .querySelector('[data-field-name="privacyPolicySigned"]')
      ?.closest('.sub-section-content-row')
    const taxRow = root
      .querySelector('[data-field-name="taxNumber"]')
      ?.closest('.sub-section-content-row')
    ;(privacyRow || taxRow || lastRow).insertAdjacentElement('afterend', wrap)

    mountContactRolesEditTable(wrap, { contactId })
    return true
  }

  function initContactRolesPropertySection(host, propertyId, roleType) {
    const id = Number(propertyId)
    if (!host || !Number.isInteger(id) || id <= 0) return false
    const roleTypeFilter =
      roleType === 'internal' || roleType === 'external' ? roleType : ''
    const mountedKey = `${id}:${roleTypeFilter || 'all'}`
    if (
      host.dataset.impowerxPropertyRoles === mountedKey &&
      host._contactRolesMounted
    ) {
      return true
    }
    host.dataset.impowerxPropertyRoles = mountedKey
    host._contactRolesMounted = true
    mountContactRolesEditTable(host, {
      propertyId: id,
      roleType: roleTypeFilter || null,
    })
    return true
  }

  function initContactRolesViewSection() {
    const contactId = getViewContactId()
    if (!contactId) return false

    const isPerson = /view-person/.test(window.location.pathname)
    const host = isPerson
      ? document.querySelector('.PersonData .basic-info.section')
      : document.querySelector('.ant-card.data-card .basic-info.section') ||
        document.querySelector('.ant-card.data-card')
    if (!host) return false

    const existing = document.querySelector(
      '[data-impowerx-view-contact-roles="true"]'
    )
    if (existing) {
      if (
        existing._contactId === contactId &&
        document.body.contains(existing)
      ) {
        return true
      }
      existing.remove()
    }

    const block = document.createElement('div')
    block.dataset.impowerxViewContactRoles = 'true'
    block._contactId = contactId
    block.className = isPerson ? '' : 'basic-info section'
    // Company cards need a section gap; person basic-info uses the same spacing
    // as native label/value rows (no extra margin).
    if (!isPerson) {
      block.style.marginTop = '12px'
    }
    block.innerHTML = `
      <div class="label">Rollen</div>
      <div class="value" data-field-name="impowerxContactRolesViewValue">Lade…</div>
    `
    host.appendChild(block)

    ;(async () => {
      const valueEl = block.querySelector(
        '[data-field-name="impowerxContactRolesViewValue"]'
      )
      try {
        const data = await luxRequestJson(
          `/api/impowerX/contacts/${contactId}/roles`
        )
        if (!document.body.contains(block) || block._contactId !== contactId)
          return
        const assignments = data.assignments || []
        if (!assignments.length) {
          valueEl.textContent = '—'
          return
        }
        await Promise.all(
          assignments
            .filter((row) => row.propertyId)
            .map((row) => ensurePropertyCached(row.propertyId))
        )
        valueEl.innerHTML = assignments
          .map((row) => {
            const property = row.propertyId
              ? propertyCache.get(row.propertyId)
              : null
            return `<div>${escapeHtml(formatAssignmentLabel(row, property))}</div>`
          })
          .join('')
      } catch {
        if (document.body.contains(block)) {
          valueEl.textContent = 'Fehler beim Laden'
        }
      }
    })()

    return true
  }

  window.initContactRolesField = initContactRolesField
  window.initContactRolesViewSection = initContactRolesViewSection
  window.initContactRolesPropertySection = initContactRolesPropertySection
})()
